// "use strict";
// const APP_ID = "5284869",
//     CREATE_BUNDLE_TRANSACTION_API = "https://api-service.loopwork.co/bundleTransaction",
//     FILTER_BUNDLE_SP_API = "https://apiv2.loopwork.co/bundleStorefront/filterBundleSellingPlanIds",
//     GET_PRODUCT_BUNDLE_DATA_API = "https://apiv2.loopwork.co/bundleStorefront/getChildVariants?id=",
//     PRODUCT_QUANTITY_SELECTOR = ".quantity__input",
//     GET_PREPAID_SELLING_PLAN_DATA_URL = "https://api.loopwork.co/api/merchant/sellingPlanGroups/sellingPlansWithDetails?shopifyIds=",
//     productDataClass = "loopProductQuickJson",
//     loopSubscriptionContainerId = "loop-subscription-container",
//     oneTimePurchaseOptionClass = "loop-one-time-purchase-option",
//     subscriptionGroupClass = "loop-subscription-group",
//     purchaseOptionName = "loop_purchase_option",
//     sellingPlanSelectorClass = "loop-selling-plan-selector",
//     useCompareAtPrice = !0;
// async function initLoopWidget(o) {
//     try {
//         log(`start application: ${o}`);
//         const e = getLoopProductData(o);
//         setupLoopDomListeners(o), initializeWindowLoopProps();
//         const n = getLoopSellingPlanGroups(e?.selling_plan_groups);
//         e.selling_plan_groups = n;
//         const t = getLoopProductVariants(e.variants, n);
//         e.variants = t, window.loopProps[o] = {
//             product: e
//         }, await setLoopUIProperties(Shopify.shop), await processLoopBundleProduct(o), await getLoopBundleSpgs(o), showSellingPlanFieldsetLoop(o), showLoopPurchaseOptionsLabel(o), initializeLoopUI(e), listenLoopCustomEvent(), hideDifferentVariantSellingPlansLoop(e), displayLoopWidget(o), observeFormChangesLoop(e)
//     } catch (o) {
//         logError(o)
//     }
// }

// function setupLoopDomListeners(o) {
//     log(`setup dom listeners for ${o}`);
//     const e = getLoopSubscriptionContainer(o),
//         n = e.querySelectorAll(`.${oneTimePurchaseOptionClass}`),
//         t = e.querySelectorAll(`.${subscriptionGroupClass}`),
//         l = e.querySelectorAll(`input[name=${purchaseOptionName}]`),
//         i = e.querySelectorAll(`.${sellingPlanSelectorClass}`);
//     for (const o of n) o.addEventListener("click", clickOnSellingPlanGroupContainerLoop);
//     for (const o of t) o.addEventListener("click", clickOnSellingPlanGroupContainerLoop);
//     for (const o of l) o.addEventListener("click", changeInSellingPlanGroupLoop);
//     for (const o of i) o.addEventListener("change", changeInDeliveryOptionLoop);
//     log(`setup dom listeners complete for ${o}`)
// }

// function initializeWindowLoopProps() {
//     window.loopProps || (window.loopProps = {})
// }

// function getLoopSellingPlanGroups(o) {
//     return Array.isArray(o) ? o.filter((o => o.app_id === APP_ID)) : []
// }

// function getLoopProductVariants(o, e) {
//     const n = new Set(e.map((o => o.id)));
//     return o.map((o => ({
//         ...o,
//         selling_plan_allocations: o.selling_plan_allocations.filter((o => n.has(o.selling_plan_group_id)))
//     })))
// }
// async function setLoopUIProperties(o) {
//     const e = await fetchLoopUIProperties(o);
//     window.loopPropsUI = {
//         ...e
//     }
// }
// async function fetchLoopUIProperties(o) {
//     log(`fetch loop subscription UI props: ${o}`);
//     const e = `https://d217z8zw4dqir.cloudfront.net/${o}.json`,
//         n = await fetch(e);
//     return await n.json() ?? {}
// }

// function showSellingPlanFieldsetLoop(o) {
//     const e = getLoopSubscriptionContainer(o).querySelector("#loop-selling-plan-fieldset");
//     e && e.classList.remove("loop-display-none", "loop-display-none-by-variant")
// }

// function showLoopPurchaseOptionsLabel(o) {
//     const e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
//     if (e)
//         for (const o of e) o.classList.remove("loop-display-none", "loop-display-none-by-variant")
// }

// function initializeLoopUI(o) {
//     let e = getVariantIdFromURLLoop(o.variants);
//     e || (e = getFirstAvailableVariantVariantIdLoop(o.id)), loopInit({
//         productId: o.id,
//         product: o,
//         variantId: e
//     })
// }

// function getVariantIdFromURLLoop(o) {
//     const e = document.URL,
//         n = new URL(e).searchParams.get("variant") || "";
//     return new Set(o?.map((o => o.id))).has(Number(n)) ? n : null
// }

// function getFirstAvailableVariantVariantIdLoop(o) {
//     const e = getLoopProductData(o),
//         n = e?.variants.find((o => o.available)),
//         t = n?.id;
//     return t
// }

// function displayLoopWidget(o) {
//     const e = getLoopSubscriptionContainer(o);
//     e && e.classList.remove("loop-display-none")
// }

// function observeFormChangesLoop(o) {
//     document.querySelectorAll("form").forEach((e => {
//         const n = e.querySelector('[name="id"]'),
//             t = e.querySelector('[name="loop_variant_id"]');
//         t && n?.value && (t.value = n.value);
//         const l = new Set(o?.variants?.map((o => o.id)));
//         if (n?.value && l.has(Number(n?.value))) {
//             const l = {
//                 attributes: !0,
//                 childList: !0,
//                 subtree: !0
//             };
//             new MutationObserver(((e, l) => {
//                 const i = n?.value ?? "";
//                 i && t && i !== (t?.value ?? "") && (t.value = i, loopVariantChanged({
//                     loopProduct: o,
//                     variantId: i
//                 }))
//             })).observe(e, l)
//         }
//     }))
// }
// const loopPriceSelectors = [".price:not(.price--on-sale) .price__regular .price-item--regular", ".price.price--on-sale .price__sale .price-item--sale", ".product-single__prices .product__price:not(.product__price--compare)", ".product-pricing .product--price .price--main .money", "[data-zp-product-discount-price]", ".product-single__header .product__price", ".modal_price .current_price", ".product-area__col--price .current-price.theme-money", '[data-product-type="price"][data-pf-type="ProductPrice"]', ".product__price .fs-heading-4-base[data-price]", "#product-price .money[data-product-price]", "#ProductPrice", ".product-single__price", ".price:not(.price--on-sale) span.price-item--regular", ".product-price .price .money:not(.original)", ".price-box #price .price", ".product__price span[data-product-price]", ".product-form--price-wrapper .product-form--price", ".product-page--pricing--variant-price #price-field", ".price-reviews .product-price"],
//     arrToInstanceCountObjLoop = o => o.reduce(((o, e) => (o[e] = (o[e] || 0) + 1, o)), {});

// function findSelectedVariantLoop(o, e) {
//     const n = getProductFromLoopProps(o) || getLoopProductData(o);
//     return findVariantByIdLoop(n, determineSelectedVariantIdLoop(e, o, n))
// }

// function getProductFromLoopProps(o) {
//     return window.loopProps?.[o]?.product
// }

// function determineSelectedVariantIdLoop(o, e, n) {
//     return o || (window.loopProps?.[e]?.selectedVariantId ? window.loopProps[e].selectedVariantId : n.variants?.[0]?.id)
// }

// function findVariantByIdLoop(o, e) {
//     return o.variants?.find((o => Number(o.id) === Number(e)))
// }

// function defaultSelectFirstSellingPlanLoop(o, e) {
//     const n = getLoopSubscriptionContainer(e).querySelectorAll("input[name=loop_purchase_option]") || [];
//     let t = !0;
//     const {
//         selling_plan_allocations: l
//     } = o, i = l?.map((o => o.selling_plan_group_id)) || [];
//     n.forEach((n => {
//         Number(n.dataset.variantId) === Number(o.id) && (window.loopProps[e].previousSPGId && i.includes(window.loopProps[e].previousSPGId) ? n.dataset.id == window.loopProps[e].previousSPGId : t) && (t = !1, n.checked = !0, setTimeout((() => {
//             if (loopIsTouchDevice()) {
//                 const {
//                     dataset: o
//                 } = n;
//                 changeInSellingPlanGroupLoopMobile(o.id, o.name, o.productId)
//             }
//             n.click()
//         }), 300))
//     }))
// }

// function hideLoopPurchaseOptionsLabel(o) {
//     const e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
//     if (e)
//         for (const o of e) o.classList.add("loop-display-none", "loop-display-none-by-variant")
// }

// function addLoopPurchaseOptionLabelText(o) {
//     let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
//     e && e.forEach((o => {
//         o && (o.innerHTML = `${window.loopPropsUI.loopPurchaseOptionslabel||"Purchase Options"}`)
//     }))
// }

// function addLoopOneTimePurchaseOptionLabelText(o) {
//     let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-one-time-purchase-option-label");
//     e && e.forEach((o => {
//         o && (o.innerHTML = `${window.loopPropsUI.loopOneTimePurchaselabel||"One time Purchase"}`)
//     }))
// }

// function showOneTimePurchaseOptionAtBottomLoop(o) {
//     const e = getLoopSubscriptionContainer(o),
//         n = e.querySelector("#loop-one-time-purchase-option-at-top"),
//         t = e.querySelector("#loop-one-time-purchase-option-at-bottom");
//     n && t && n.innerHTML && (t.innerHTML = n.innerHTML, n.innerHTML = "");
//     e.querySelectorAll(".loop-subscription-group").forEach((o => {
//         o.classList.remove("loop-subscription-group-border-top"), o.classList.add("loop-subscription-group-border-bottom")
//     }))
// }

// function hideEachLabelForPriceLoop() {
//     [".loop-subscription-group-price-quantity", ".loop-one-time-purchase-option-price-quantity"].forEach((o => {
//         document.querySelectorAll(o).forEach((o => {
//             o.classList.add("loop-display-none")
//         }))
//     }))
// }

// function displayLoopTooltip(o) {
//     const e = getLoopSubscriptionContainer(o),
//         n = e.querySelector("#loop-tooltip");
//     if (!n) return;
//     n.classList.remove("loop-display-none"), updateLoopTooltipContent(e, "#loop-tooltip-label", window.loopPropsUI.subscriptionPopupLabel), updateLoopTooltipContent(e, "#loop-tooltip-description", window.loopPropsUI.subscriptionPopupDescription);
//     const t = e.querySelector("#loop-tooltip-label"),
//         l = e.querySelector("#loop-tooltip-description");
//     t && l && (t.style.fill = window.getComputedStyle(l).color)
// }

// function updateLoopTooltipContent(o, e, n) {
//     const t = o.querySelector(e);
//     t && n && (t.innerHTML = n)
// }

// function hideLoopTooltip(o) {
//     const e = getLoopSubscriptionContainer(o).querySelector("#loop-tooltip");
//     e && e.classList.add("loop-display-none")
// }

// function addExtraLoopStyles() {
//     if (window && window.loopPropsUI && window.loopPropsUI.style) {
//         let o = {
//             purchase_option_label: [".loop-purchase-options-label"],
//             widget_feildset: [".loop-selling-plan-fieldset"],
//             selling_plan_group_container: [".loop-one-time-purchase-option", ".loop-subscription-group"],
//             selling_plan_group_label: [".loop-one-time-purchase-option-label", ".loop-subscription-group-label"],
//             selling_plan_label: [".loop-selling-plan-selector-label"],
//             selling_plan_selector: [".loop-selling-plan-selector"],
//             selling_plan_price_label: [".loop-one-time-purchase-option-price-amount", ".loop-subscription-group-price-amount"],
//             selling_plan_price_subtitle_label: [".loop-one-time-purchase-option-price-quantity", ".loop-subscription-group-price-quantity"],
//             selling_plan_description_label: [".loop-selling-plan-selector-description"],
//             selling_plan_discount_badge_style: [".loop-subscription-group-discount-badge"],
//             subscription_details_label: [".loop-tooltip-label"],
//             subscription_details_popup: [".loop-tooltiptext", ".loop-container-arrow", ".loop-tooltip-description"],
//             selling_plan_group_selected: [".loop-selected-selling-plan-group"],
//             selling_plan_group_radio: [".loop-subscription-group-radio", ".loop-one-time-purchase-option-radio"]
//         };
//         const e = ({
//                 id: o,
//                 data: e
//             }) => {
//                 if (e) {
//                     let o = Object.keys(e),
//                         n = "";
//                     return o.forEach((o => {
//                         let t = e[o];
//                         n = ` ${n} ${o}: ${t} !important;`
//                     })), n
//                 }
//                 return ""
//             },
//             n = ({
//                 id: e,
//                 data: n
//             }) => o[e] || [];
//         let t = "";
//         const {
//             style: l
//         } = window.loopPropsUI;
//         l.map((o => {
//             n(o).map((n => {
//                 t += `\n                 ${n} {\n                     ${e(o)}\n                 }\n             `
//             }))
//         }));
//         let i = document.querySelectorAll(".loop-style");
//         i && i.forEach((o => {
//             o.innerHTML = `${o.innerHTML}\n                 ${t}\n             `
//         }))
//     }
//     if (window && window.loopPropsUI && window.loopPropsUI.cssClassess) {
//         let o = document.querySelectorAll(".loop-style");
//         o && o.forEach((o => {
//             o.innerHTML = `${o.innerHTML}\n                 ${window.loopPropsUI.cssClassess}\n             `
//         }))
//     }
// }

// function hideLoopSellingPlanFieldset(o) {
//     const e = getLoopSubscriptionContainer(o).querySelector("#loop-selling-plan-fieldset");
//     e && e.classList.add("loop-display-none", "loop-display-none-by-variant")
// }

// function applyLoopSettings({
//     productId: o
// }) {
//     let e = window.loopProps[o].product;
//     const n = findSelectedVariantLoop(o);
//     if (window && window.loopPropsUI && !1 === window.loopPropsUI.displayLoopPurchaseOptionLabel && hideLoopPurchaseOptionsLabel(o), window && window.loopPropsUI && window.loopPropsUI.loopPurchaseOptionslabel && addLoopPurchaseOptionLabelText(o), window && window.loopPropsUI && window.loopPropsUI.loopOneTimePurchaselabel && addLoopOneTimePurchaseOptionLabelText(o), window && window.loopPropsUI && window.loopPropsUI.displayOneTimePurchaseOptionAtBottom) {
//         showOneTimePurchaseOptionAtBottomLoop(o);
//         getLoopSubscriptionContainer(o).querySelectorAll(".loop-one-time-purchase-option").forEach((o => {
//             o.addEventListener("click", clickOnSellingPlanGroupContainerLoop)
//         }));
//         getLoopSubscriptionContainer(o).querySelectorAll("input[name=loop_purchase_option]").forEach((o => {
//             o.addEventListener("click", changeInSellingPlanGroupLoop)
//         }))
//     }
//     if (window && window.loopPropsUI && !1 === window.loopPropsUI.displayEachLabelForPrice && hideEachLabelForPriceLoop(), window && window.loopPropsUI && window.loopPropsUI.hidePlanSelectorIfOnlyOne) {
//         const {
//             availableSellingPlanAllocations: e = []
//         } = window.loopProps[o];
//         let t = [];
//         e.map((o => {
//             t.push(o.selling_plan_group_id)
//         }));
//         let l = arrToInstanceCountObjLoop(t);
//         Object.keys(l).forEach((o => {
//             if (1 === l[o]) {
//                 let e = `#loop-selling-plan-container-${n.id}-${o}`,
//                     t = document.querySelector(e);
//                 if (t) {
//                     let e = t.querySelector(".loop-selling-plan-selector-label"),
//                         l = t.querySelector(`#loop-selling-plan-first-delivery-options-${n.id}-${o}`),
//                         i = t.querySelector(".loop-selling-plan-selector");
//                     e && e.classList.add("loop-display-none"), l && l.classList.add("loop-display-none"), i && i.classList.add("loop-display-none")
//                 }
//             }
//         }))
//     }
//     if (window && window.loopPropsUI && window.loopPropsUI.showPlanSelectorAsTextIfOnlyOnePlan && !window.loopPropsUI.hidePlanSelectorIfOnlyOne) {
//         const {
//             availableSellingPlanAllocations: e = []
//         } = window.loopProps[o];
//         let t = [];
//         e.map((o => {
//             t.push(o.selling_plan_group_id)
//         }));
//         let l = arrToInstanceCountObjLoop(t);
//         Object.keys(l).forEach((o => {
//             if (1 === l[o]) {
//                 let e = `#loop-selling-plan-first-delivery-options-${n.id}-${o}`,
//                     t = document.querySelector(e);
//                 t && t.classList && t.classList.remove("loop-display-none"), e = `#loop-select-${n.id}-${o}`, t = document.querySelector(e), t && t.classList.add("loop-display-none")
//             }
//         }))
//     }
//     if (window && window.loopPropsUI && window.loopPropsUI.hideWholeWidgetIfOnlyOnePlan && e.requires_selling_plan && n.selling_plan_allocations && 1 === n.selling_plan_allocations.length && (hideLoopSellingPlanFieldset(o), hideLoopPurchaseOptionsLabel(o)), window && window.loopPropsUI && window.loopPropsUI.hideRadioButtonIfOnlyOnePlan && e.requires_selling_plan) {
//         const {
//             availableSellingPlanAllocations: e
//         } = window.loopProps[o];
//         let n = [];
//         e.map((o => {
//             n.push(o.selling_plan_group_id)
//         }));
//         let t = arrToInstanceCountObjLoop(n),
//             l = !1;
//         if (l = 1 === Object.keys(t).length, l) {
//             let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-subscription-group-radio");
//             e && e.forEach((o => {
//                 o.classList.add("loop-display-none")
//             }));
//             let n = getLoopSubscriptionContainer(o).querySelectorAll(".loop-subscription-group-selling-plans-container");
//             n && n.forEach((o => {
//                 o.classList.add("loop-left-margin-0")
//             }))
//         }
//     }
//     if (addExtraLoopStyles(), window && window.loopPropsUI && window.loopPropsUI.displaySubscriptionPopup && n && n.selling_plan_allocations && n.selling_plan_allocations.length ? displayLoopTooltip(o) : hideLoopTooltip(o), e && e.requires_selling_plan && Array.isArray(n.selling_plan_allocations) && n.selling_plan_allocations.length) {
//         let e = `#loop-product-variant-${n.id}`,
//             t = getLoopSubscriptionContainer(o).querySelector(e);
//         if (window && window.loopPropsUI && window.loopPropsUI.displayOneTimePurchaseOptionAtBottom) {
//             let o = ".loop-subscription-group",
//                 e = t.querySelectorAll(o);
//             if (e && e.length) {
//                 let o = e[e.length - 1];
//                 o.style.borderBottom = "0", o.classList.remove("loop-subscription-group-border-bottom")
//             }
//         } else {
//             let o = ".loop-subscription-group",
//                 e = t.querySelectorAll(o);
//             if (e && e.length) {
//                 let o = e[0];
//                 o.style.borderTop = "0", o.classList.remove("loop-subscription-group-border-top")
//             }
//         }
//     }
//     if (window && window.loopPropsUI && window.loopPropsUI.displayDiscountBadge) displayLoopDiscountBadge({
//         productId: o
//     });
//     else {
//         let o = document.querySelectorAll(".loop-subscription-group-discount-badge");
//         o && o.forEach((o => {
//             o && o.classList.add("loop-display-none")
//         }))
//     }
//     if (window && window.loopPropsUI && window.loopPropsUI.translationData) {
//         let o = window.loopPropsUI.translationData || {},
//             e = {
//                 widget_price_label_text: [".loop-one-time-purchase-option-price-quantity", ".loop-subscription-group-price-quantity"]
//             };
//         Object.keys(e).forEach((n => {
//             if (o && o[n]) {
//                 e[n].map((e => {
//                     let t = document.querySelectorAll(e);
//                     t && t.forEach((e => {
//                         e.innerText = o[n]
//                     }))
//                 }))
//             }
//         }))
//     }
// }

// function clickOnSellingPlanGroupContainerLoop(o) {
//     const e = o.target.closest(".loop-subscription-group") || o.target.closest(".loop-one-time-purchase-option");
//     if (!e) return;
//     const n = e.querySelector('input[type="radio"]'),
//         t = window.loopProps[n.dataset.productId]?.sellingPlanGroupId;
//     n?.dataset?.id !== t && n.click()
// }

// function loopVariantChanged({
//     loopProduct: o,
//     variantId: e
// }) {
//     loopInit({
//         productId: o.id,
//         product: JSON.parse(JSON.stringify(o)),
//         variantId: e
//     })
// }

// function checkVariantsSellingPlanAllocationLoop(o, e) {
//     o?.selling_plan_allocations?.length > 0 ? (showSellingPlanFieldsetLoop(e), showLoopPurchaseOptionsLabel(e)) : (hideLoopSellingPlanFieldset(e), hideLoopPurchaseOptionsLabel(e))
// }

// function defaultSelectOneTimePurchaseOptionLoop(o, e) {
//     const n = getLoopSubscriptionContainer(e).querySelector(`#loop-one-time-purchase-${e}`);
//     if (n) {
//         if (n.checked = !0, n.click(), loopIsTouchDevice()) {
//             const {
//                 dataset: o
//             } = n;
//             changeInSellingPlanGroupLoopMobile(o.id, o.name, o.productId)
//         }
//     } else defaultSelectFirstSellingPlanLoop(o, e)
// }

// function loopInit({
//     productId: o,
//     product: e,
//     variantId: n
// }) {
//     updateLoopProperties({
//         product: e,
//         productId: o,
//         variantId: n
//     });
//     const t = findSelectedVariantLoop(o, n);
//     toggleVariantDisplayLoop(e, t.id), checkVariantsSellingPlanAllocationLoop(t, o), applyLoopSettings({
//         productId: o
//     }), applyDefaultSelectionBasedOnLoopSettings(t, o), hideLoopBundleSPG(o)
// }

// function toggleVariantDisplayLoop(o, e) {
//     o.variants.forEach((o => {
//         const n = o.id === e ? "block" : "none";
//         document.querySelector(`#loop-product-variant-${o.id}`).style.display = n
//     }))
// }

// function applyDefaultSelectionBasedOnLoopSettings(o, e) {
//     if (window.loopHasInitializedDefaults[e] && window.loopPurchaseChoice[e]) {
//         return void("subscription" === window.loopPurchaseChoice[e] ? defaultSelectFirstSellingPlanLoop(o, e) : defaultSelectOneTimePurchaseOptionLoop(o, e))
//     }
//     const n = window.loopPropsUI?.byDefaultChooseSubscriptionOption;
//     n ? (defaultSelectFirstSellingPlanLoop(o, e), window.loopPurchaseChoice[e] = "subscription") : (defaultSelectOneTimePurchaseOptionLoop(o, e), window.loopPurchaseChoice[e] = "one_time"), window.loopHasInitializedDefaults[e] = !0
// }

// function updateSelectDropDownDefaultValuesLoop({
//     productId: o,
//     variant: e,
//     sellingPlanGroupId: n
// }) {
//     const t = window.loopProps[o].product.selling_plan_groups;
//     Array.isArray(t) && t.length && t.forEach((o => {
//         n !== o.id && resetSelectDropdownLoop(e.id, o.id)
//     }))
// }

// function resetSelectDropdownLoop(o, e) {
//     const n = document.getElementById(`loop-select-${o}-${e}`);
//     n && (n.options[0].selected = !0)
// }

// function changeInSellingPlanGroupLoopMobile(o, e, n) {
//     window.loopPurchaseChoice || (window.loopPurchaseChoice = {}), window.loopPurchaseChoice[n] = "loop-one-time-purchase" === o ? "one_time" : "subscription", window.loopProps || (window.loopProps = {}), window.loopProps[n] || (window.loopProps[n] = {}), window.loopProps[n].previousSPGId = o;
//     const t = findSelectedVariantLoop(n, window.loopProps[n].selectedVariantId);
//     let l = t.selling_plan_allocations.filter((e => e.selling_plan_group_id === o)) || [],
//         i = l && l.length ? l[0] : {},
//         p = i.selling_plan_id;
//     updateLoopProperties({
//         productId: n,
//         variantId: t.id,
//         sellingPlanGroupId: o,
//         sellingPlanGroupName: e,
//         sellingPlanId: p,
//         sellingPlan: i
//     }), updateSelectDropDownDefaultValuesLoop({
//         productId: n,
//         variant: t,
//         sellingPlanGroupId: o
//     }), updatePriceInParentElementsLoop({
//         productId: n
//     }), updateLoopSellingPlanDescriptionUI({
//         productId: n
//     }), displayLoopDiscountBadge({
//         productId: n
//     }), updateCartButtonTextLoop({
//         productId: n
//     }), updatePriceInUILoop({
//         productId: n
//     }), updatePrepaidPriceInUILoop({
//         productId: n
//     }), applyLoopBundleDiscount(n), checkAllowCheckoutIfBundle(n);
//     let r = getLoopSubscriptionContainer(n).querySelectorAll(".loop-selected-selling-plan-group");
//     if (r && r.forEach((o => {
//             o && o.classList.remove("loop-selected-selling-plan-group")
//         })), "loop-one-time-purchase" === o) {
//         let o = getLoopSubscriptionContainer(n).querySelectorAll(".loop-one-time-purchase-option");
//         o && o.forEach((o => {
//             o.classList.add("loop-selected-selling-plan-group")
//         }))
//     } else {
//         let e = `#loop-${t.id}-${o}`,
//             l = getLoopSubscriptionContainer(n).querySelector(e);
//         l && l.classList.add("loop-selected-selling-plan-group")
//     }
// }

// function changeInSellingPlanGroupLoop(o) {
//     let e = o.target.dataset.id,
//         n = o.target.dataset.name,
//         t = o.target.dataset.productId;
//     window.loopPurchaseChoice || (window.loopPurchaseChoice = {}), window.loopPurchaseChoice[t] = "loop-one-time-purchase" === e ? "one_time" : "subscription", window.loopProps || (window.loopProps = {}), window.loopProps[t] || (window.loopProps[t] = {}), window.loopProps[t].previousSPGId = e;
//     const l = findSelectedVariantLoop(t, window.loopProps[t].selectedVariantId);
//     let i = l.selling_plan_allocations.filter((o => o.selling_plan_group_id === e)) || [],
//         p = i && i.length ? i[0] : {},
//         r = p.selling_plan_id;
//     updateLoopProperties({
//         productId: t,
//         variantId: l.id,
//         sellingPlanGroupId: e,
//         sellingPlanGroupName: n,
//         sellingPlanId: r,
//         sellingPlan: p
//     }), updateSelectDropDownDefaultValuesLoop({
//         productId: t,
//         variant: l,
//         sellingPlanGroupId: o.target.dataset.id
//     }), updatePriceInParentElementsLoop({
//         productId: t
//     }), updateLoopSellingPlanDescriptionUI({
//         productId: t
//     }), displayLoopDiscountBadge({
//         productId: t
//     }), updateCartButtonTextLoop({
//         productId: t
//     }), updatePriceInUILoop({
//         productId: t
//     }), updatePrepaidPriceInUILoop({
//         productId: t
//     }), applyLoopBundleDiscount(t), checkAllowCheckoutIfBundle(t);
//     let a = getLoopSubscriptionContainer(t).querySelectorAll(".loop-selected-selling-plan-group");
//     if (a && a.forEach((o => {
//             o && o.classList.remove("loop-selected-selling-plan-group")
//         })), "loop-one-time-purchase" === e) {
//         let o = getLoopSubscriptionContainer(t).querySelectorAll(".loop-one-time-purchase-option");
//         o && o.forEach((o => {
//             o.classList.add("loop-selected-selling-plan-group")
//         }))
//     } else {
//         let o = `#loop-${l.id}-${e}`,
//             n = getLoopSubscriptionContainer(t).querySelector(o);
//         n && n.classList.add("loop-selected-selling-plan-group")
//     }
// }

// function changeInDeliveryOptionLoop(o) {
//     let e = o.target.value,
//         n = o.target.dataset.productId;
//     updateLoopProperties({
//         productId: n,
//         sellingPlanId: e
//     }), updatePriceInParentElementsLoop({
//         productId: n
//     }), updateLoopSellingPlanDescriptionUI({
//         productId: n
//     }), displayLoopDiscountBadge({
//         productId: n
//     }), updatePriceInUILoop({
//         productId: n
//     }), updatePrepaidPriceInUILoop({
//         productId: n
//     }), applyLoopBundleDiscount(n), checkAllowCheckoutIfBundle(n)
// }

// function displayLoopDiscountBadge({
//     productId: o
// }) {
//     const e = window.loopProps[o]?.prepaidSellingPlans || {},
//         n = findSelectedVariantLoop(o),
//         {
//             selling_plan_groups: t
//         } = window.loopProps[o].product;
//     window && window.loopProps && window.loopPropsUI.displayDiscountBadge ? t.map((t => {
//         const {
//             selling_plans: l
//         } = t, i = l[0];
//         let p = e[i.id]?.deliveriesPerBillingCycle || 1,
//             r = [];
//         l.map((o => {
//             const t = e[o.id]?.deliveriesPerBillingCycle || 1,
//                 {
//                     price_adjustments: l
//                 } = o;
//             let i = l.length ? l[0] : {};
//             r.push({
//                 value: i.value / t,
//                 value_type: i.value_type,
//                 amount: "fixed_amount" === i.value_type ? i.value : "price" === i.value_type ? Number(n.price) - Number(i.value / t) : Number(n.price) * i.value / 100
//             })
//         }));
//         let a = r.reduce(((o, e) => o.amount > e.amount ? o : e));
//         if (p > 1) {
//             const o = n.selling_plan_allocations.find((o => o.selling_plan_group_id === t.id));
//             let i = l.find((e => e.id === Number(o.selling_plan_id))) || {};
//             a = i.price_adjustments[0], p = e[i.id]?.deliveriesPerBillingCycle || 1
//         }
//         let s = `#loop-discount-badge-${n.id}-${t.id}`,
//             d = getLoopSubscriptionContainer(o).querySelector(s);
//         if (window.loopProps[o] && t.id === window.loopProps[o].sellingPlanGroupId) {
//             let n = l.find((e => e.id === Number(window.loopProps[o].sellingPlanId))) || {};
//             a = n.price_adjustments[0], p = e[n.id]?.deliveriesPerBillingCycle || 1
//         }
//         if (d) {
//             let o = "";
//             if (a && "fixed_amount" === a.value_type) o = loopFormatMoney(a.value, !0);
//             else if (a && "percentage" === a.value_type) o = `${a.value}%`;
//             else if (a && "price" === a.value_type)
//                 if (p > 1) {
//                     const e = (Number(n.price) - Number(a.value / p)) / Number(n.price) * 100;
//                     o = `${Math.round(e>0?e:0)}%`
//                 } else o = loopFormatMoney(Number(n.price) - Number(a.value / p) > 0 ? Number(n.price) - Number(a.value / p) : 0, !0);
//             let e = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", o);
//             d.innerHTML = `${e}`, !a?.value && !Number(a?.value) || a && "price" === a.value_type && Math.round(Number(n.price) - Number(a.value / p)) <= 0 ? d.classList.add("loop-display-none") : d.classList.remove("loop-display-none")
//         }
//     })) : t.map((o => {
//         let e = `#loop-discount-badge-${n.id}-${o.id}`,
//             t = document.querySelector(e);
//         t && t.classList.add("loop-display-none")
//     }))
// }

// function calculateCurrentSellingPlanLoop({
//     productId: o,
//     availableSellingPlanAllocations: e
// }) {
//     const n = window.loopProps[o],
//         {
//             sellingPlanId: t,
//             sellingPlanGroupId: l
//         } = n;
//     return e.find((o => o.selling_plan_group_id === l && (!t || Number(o.selling_plan_id) === Number(t)))) || {}
// }

// function updateLoopProperties({
//     product: o,
//     productId: e,
//     variantId: n,
//     sellingPlanGroupId: t,
//     sellingPlanGroupName: l,
//     sellingPlanId: i
// }) {
//     let p = getLoopSubscriptionContainer(e).querySelector("#loop-selling-plan-fieldset");
//     n && (Number(n) !== Number(p.dataset.selectedVariantId) && (p.dataset.sellingPlanGroupId = "", p.dataset.sellingPlanGroupName = "", p.dataset.sellingPlanId = ""), p.dataset.selectedVariantId = n), t && (p.dataset.sellingPlanGroupId = t), l && (p.dataset.sellingPlanGroupName = l), o && (p.dataset.product = JSON.stringify(o)), i ? p.dataset.sellingPlanId = i : "loop-one-time-purchase" === t && (p.dataset.sellingPlanId = "", p.dataset.sellingPlan = {}, p.dataset.sellingPlan = {}), window.loopProps || (window.loopProps = {}, window.loopProps[e] = {
//         product: o,
//         productId: e
//     });
//     const r = window.loopProps[e].productBundleData,
//         a = window.loopProps[e].previousSPGId,
//         s = window.loopProps[e].bundleSPGS,
//         d = window.loopProps[e].nonBundleSPGS,
//         c = window.loopProps[e].prepaidSellingPlans,
//         u = window.loopProps[e].product;
//     window.loopProps[e] = {
//         ...p.dataset,
//         productId: e
//     }, window.loopProps[e].productBundleData = r, window.loopProps[e].previousSPGId = a, window.loopProps[e].prepaidSellingPlans = c, window.loopProps[e].product = u, window.loopProps[e].bundleSPGS = s, window.loopProps[e].nonBundleSPGS = d;
//     let g = findSelectedVariantLoop(e),
//         w = g && Array.isArray(g.selling_plan_allocations) ? g.selling_plan_allocations : [];
//     window.loopProps[e].availableSellingPlanAllocations = w, window.loopProps[e].variant = g;
//     let P = calculateCurrentSellingPlanLoop({
//             availableSellingPlanAllocations: w,
//             productId: e
//         }),
//         L = P.selling_plan_id || "";
//     window.loopProps[e].sellingPlan = P;
//     let f = w.find((o => {
//         if (L && Number(o.selling_plan_id) === Number(L)) return !0
//     }));
//     window.loopProps[e].sellingPlanAllocation = f;
//     const {
//         selling_plan_groups: _
//     } = window.loopProps[e].product;
//     window.loopProps[e].sellingPlanDefination = {}, window.loopProps[e].sellingPlanPriceAdjustments = [], _ && Array.isArray(_) && _.map((o => {
//         if (o.id === window.loopProps[e].sellingPlanGroupId) {
//             const {
//                 selling_plans: n
//             } = o;
//             n.map((o => {
//                 o.id === Number(window.loopProps[e].sellingPlanId) && (window.loopProps[e].sellingPlanDefination = o, window.loopProps[e].sellingPlanPriceAdjustments = o.price_adjustments)
//             }))
//         }
//     }));
//     let y = getLoopSubscriptionContainer(e).querySelector('[name="selling_plan"]');
//     y && (y.value = L), document.querySelectorAll(`form[data-loop-product-id="${e}"]`).forEach((o => {
//         const e = o.querySelectorAll('input[name="selling_plan"]');
//         e.length && e.forEach((o => {
//             o.remove()
//         }));
//         const n = document.createElement("input");
//         n.type = "hidden", n.name = "selling_plan", n.value = L, o.appendChild(n)
//     }))
// }

// function updateCartButtonTextLoop({
//     productId: o
// }) {
//     const e = document.querySelector(`[data-loop-product-id="${o}"]`) || document,
//         n = determineOneTimeOrderLoop(o),
//         t = getAddToCartButtonLoop(e);
//     if (!t) return;
//     updateButtonInnerHTMLLoop(t, getButtonTextLoop(n, o))
// }

// function determineOneTimeOrderLoop(o) {
//     const e = window?.loopProps[o]?.sellingPlanGroupId;
//     return !e || "loop-one-time-purchase" === e
// }

// function getAddToCartButtonLoop(o) {
//     let e = null;
//     return ["button[type='submit'][name='add']", "button[type='button'][name='add']"].map((n => {
//         e || (e = o.querySelector(n)), e || (e = document.querySelector(n))
//     })), e
// }

// function getButtonTextLoop(o, e) {
//     return o ? window.loopProps[e].variant.available ? window?.loopPropsUI?.translationData?.widget_add_to_cart_button_for_one_time_purchase || "Add to cart" : window?.loopPropsUI?.translationData?.widget_out_of_stock_text || "Out of Stock" : window?.loopPropsUI?.translationData?.widget_add_to_cart_button_for_subscription || "Add subscription to cart"
// }

// function updateButtonInnerHTMLLoop(o, e) {
//     o.firstElementChild ? o.firstElementChild.innerHTML = e : o.innerHTML = e
// }

// function loopFormatMoney(o, e) {
//     if (Shopify.locale && Shopify.country && Shopify.currency.active) return loopFormatPriceNew(o, Shopify.locale, Shopify.country, Shopify.currency.active);
//     let n = loopFormatPrice(o, document.querySelector("#loop-price-money-format").innerText, document.querySelector("#loop-price-money_without_currency-format").innerText);
//     return e && (n = n.replace("each", "")), n.trim()
// }

// function loopFormatPriceNew(o, e, n, t) {
//     const l = o / 100;
//     return new Intl.NumberFormat(`${e}-${n}`, {
//         style: "currency",
//         currency: `${t}`
//     }).format(l)
// }

// function loopFormatPrice(o, e, n) {
//     const t = o / 100;
//     if (e.includes("0.00")) return e.replace("0.00", t.toFixed(2));
//     if (e.includes("0,00")) return e.replace("0,00", t.toFixed(2).replace(".", ","));
//     if (e.includes("0")) {
//         const o = Number(n.replace("0", t)).toFixed(0);
//         return e.replace("0", o)
//     }
//     return e
// }

// function getSavedPriceLabel(o) {
//     if (!Array.isArray(o) || !o.length) return "";
//     const e = o[0];
//     return "percentage" === e.value_type ? `Save ${e.value}%` : `Save ${loopFormatMoney(e.value,!0)}`
// }

// function updateLoopSellingPlanDescriptionUI({
//     productId: o
// }) {
//     const e = findSelectedVariantLoop(o),
//         n = window.loopProps?.[o];
//     if (!n?.sellingPlanGroupId) return;
//     const t = n?.sellingPlanDefination?.description || "";
//     updateLoopSellingPlanDescriptionElement(document.querySelector(`#loop-selling-plan-description-${e.id}-${n.sellingPlanGroupId}`), t)
// }

// function updateLoopSellingPlanDescriptionElement(o, e) {
//     o && (o.innerHTML = e, e ? o.classList.remove("loop-display-none") : o.classList.add("loop-display-none"))
// }

// function updatePriceInParentElementsLoop({
//     productId: o
// }) {
//     const e = getCurrentPathLoop(),
//         n = window?.loopProps[o]?.product?.handle;
//     if (n !== e) return;
//     const t = determinePriceLoop(o, findSelectedVariantLoop(o));
//     loopPriceSelectors.push(`.loop-product-${o}`), updatePricesInUILoop(t)
// }

// function determinePriceLoop(o, e) {
//     const n = window?.loopProps[o]?.sellingPlanAllocation?.price;
//     return loopFormatMoney(n || e.price, !0)
// }

// function updatePricesInUILoop(o) {}

// function updatePriceInUILoop({
//     productId: o
// }) {
//     let e = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
//         n = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
//     const t = window.loopProps[o]?.product || {},
//         {
//             selling_plan_groups: l
//         } = t,
//         {
//             selling_plan_allocations: i
//         } = e;
//     if (l.map((o => {
//             if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
//                 let n = o.selling_plans[0],
//                     t = i.find((o => Number(o.selling_plan_id) === Number(n.id))) || {};
//                 const {
//                     selling_plan_group_id: l,
//                     per_delivery_price: p
//                 } = t;
//                 let r = document.querySelector(`#loop-price-${e.id}-${l}`);
//                 r && (r.innerHTML = loopFormatMoney(p, !0))
//             }
//         })), n && n.selling_plan_group_id) {
//         const {
//             selling_plan_group_id: o,
//             per_delivery_price: t
//         } = n;
//         let l = document.querySelector(`#loop-price-${e.id}-${o}`);
//         l && (l.innerHTML = loopFormatMoney(t, !0))
//     }
//     let p = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time");
//     if (p) {
//         p.innerHTML = loopFormatMoney(e.price, !0), document.querySelectorAll(".loop-subscription-group-price-amount-original").forEach((o => {
//             o.innerHTML = loopFormatMoney(e.price, !0)
//         }))
//     }
// }

// function log(o) {
//     console.log(o)
// }

// function logError(o) {
//     console.error(o)
// }

// function initializeLoopData(o) {
//     window.LoopSubscriptions || (window.LoopSubscriptions = {}), window.LoopSubscriptions[o] = getLoopProductData(o)
// }

// function getLoopProductData(o) {
//     const e = document.querySelector(`.${productDataClass}-${o}`).textContent;
//     return JSON.parse(e)
// }

// function getLoopSubscriptionContainer(o) {
//     return document.querySelector(`#${loopSubscriptionContainerId}-${o}`)
// }

// function getCurrentPathLoop() {
//     const o = window.location.pathname.split("/");
//     return o[o.length - 1]
// }

// function loopIsTouchDevice() {
//     return "ontouchstart" in document.documentElement
// }
// async function getLoopBundleSpgs(o) {
//     const e = loopProps[o]?.product?.selling_plan_groups?.flatMap((o => o?.selling_plans?.map((e => ({
//             selling_plan_group_id: o.id,
//             selling_plan_id: e.id
//         }))))) || [],
//         n = loopProps[o]?.product?.selling_plan_groups?.flatMap((o => o?.selling_plans.map((o => o.id)))) || [],
//         t = {
//             domain: window.Shopify.shop,
//             sellingPlanIds: n,
//             product_shopify_id: o
//         },
//         l = n.join(","),
//         i = `${GET_PREPAID_SELLING_PLAN_DATA_URL}${l}`;
//     try {
//         const [n, l] = await Promise.all([fetch(FILTER_BUNDLE_SP_API, {
//             method: "POST",
//             body: JSON.stringify(t),
//             headers: {
//                 "Content-Type": "application/json"
//             }
//         }), fetch(i, {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json"
//             }
//         })]), p = (await n.json()).data;
//         let r = [],
//             a = [];
//         for (const o of e) p.includes(o.selling_plan_id) ? r.push(o.selling_plan_group_id) : a.push(o.selling_plan_group_id);
//         window.loopProps[o].bundleSPGS = [...new Set(r)], window.loopProps[o].nonBundleSPGS = [...new Set(a)], hideLoopBundleSPG(o);
//         const s = (await l.json()).data;
//         window.loopProps[o].prepaidSellingPlans = s?.sellingPlans || null
//     } catch (o) {
//         console.error("getLoopBundleSpgs", o)
//     }
// }

// function hideLoopBundleSPG(o) {
//     if (!window.loopProps?.[o]?.productBundleData?.isBundleProduct) {
//         const e = window.loopProps[o],
//             n = getLoopSubscriptionContainer(o);
//         if (n) {
//             const t = e.bundleSPGS;
//             t?.length && (t.forEach((o => {
//                 const e = n.querySelectorAll(`#loop-selling_plan_group-${o}`);
//                 e?.length && e.forEach((o => {
//                     o.classList.add("loop-display-none")
//                 }))
//             })), clickUpdatedSPGLoop(o))
//         }
//     }
// }

// function clickUpdatedSPGLoop(o) {
//     showSellingPlanFieldsetLoop(o), window && window.loopPropsUI && window.loopPropsUI.displayLoopPurchaseOptionLabel ? showLoopPurchaseOptionsLabel(o) : hideLoopPurchaseOptionsLabel(o);
//     const e = window.loopProps[o].selectedVariantId;
//     let n = window.loopProps[o].nonBundleSPGS ?? [];
//     window.loopProps[o].bundleSPGS;
//     const t = window.loopProps[o].product.variants,
//         l = getVariantIdFromURLLoop(t) ?? getFirstAvailableVariantVariantIdLoop(o),
//         i = (t.find((o => o.id == l)) ?? t[0]).selling_plan_allocations.map((o => o.selling_plan_group_id));
//     if (n = n.filter((o => i.includes(o))), 0 !== n.length && window.loopPropsUI.byDefaultChooseSubscriptionOption) {
//         showLoopWidget(o);
//         const t = n[0];
//         getLoopSubscriptionContainer(o).querySelectorAll(`#loop-selling_plan_group-${t}`).forEach((o => {
//             o.querySelectorAll(`#loop-allocation-${t}`).forEach((o => {
//                 o.querySelectorAll(`#loop-${e}-${t}`).forEach((o => {
//                     o.click()
//                 }))
//             }))
//         }))
//     } else 0 === n.length && hideLoopWidget(o), setTimeout((() => defaultSelectOneTimePurchaseOptionLoop(e, o)), 500)
// }

// function showLoopWidget(o) {
//     const e = document.getElementById(`loop-subscription-container-${o}`);
//     e && (e.style.display = "block")
// }

// function hideLoopWidget(o) {
//     const e = document.getElementById(`loop-subscription-container-${o}`);
//     e && (e.style.display = "none")
// }
// async function getBundleDataByProductId(o) {
//     const e = await fetch(`${GET_PRODUCT_BUNDLE_DATA_API}${o}`);
//     return (await e.json()).data
// }

// function handleBundleWidgetVisibility(o) {
//     "SUBSCRIPTION" === window.loopProps[o].productBundleData.purchaseType ? hideOneTimePurchaseOptionLoop(o) : "ONETIME" === window.loopProps[o].productBundleData.purchaseType && (hideLoopSellingPlanFieldset(o), hideLoopPurchaseOptionsLabel(o), defaultSelectOneTimePurchaseOptionLoop(null, o))
// }
// async function processLoopBundleProduct(o) {
//     try {
//         const e = await getBundleDataByProductId(o);
//         e && (window.loopProps[o].productBundleData = e, e.isBundleProduct && (overrideAddToCartButtonLoop(o, e.mapping), handleBundleWidgetVisibility(o), applyLoopBundleDiscount(o), checkAllowCheckoutIfBundle(o)))
//     } catch (o) {
//         console.error("processLoopBundleProduct", o)
//     }
// }

// function checkAllowCheckoutIfBundle(o) {
//     enableAddToCartBtnLoop(o);
//     const e = window.loopProps[o].selectedVariantId;
//     if (window.loopProps[o]?.productBundleData?.isBundleProduct) {
//         const n = window.loopProps[o].productBundleData.mapping[e],
//             t = n?.allowCheckout,
//             l = n?.outOfStock;
//         if (l) {
//             const e = window?.loopPropsUI?.translationData?.widget_out_of_stock_text || "Out of Stock",
//                 n = getAddToCartButtonLoop(document.querySelector(`[data-loop-product-id="${o}"]`) || document);
//             n && setTimeout((() => {
//                 updateButtonInnerHTMLLoop(n, e)
//             }), 500)
//         }
//         t && !l || disableAddToCartBtnLoop(o)
//     }
// }

// function applyLoopBundleDiscount(o) {
//     if (!window.loopProps[o]?.productBundleData?.isBundleProduct) return;
//     const e = window.loopProps[o].productBundleData;
//     let n = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
//         t = window.loopProps[o].selectedVariantId;
//     const l = e.productVariantDiscountMapping?.[t];
//     if (!l) return;
//     const i = window.Shopify.currency.rate;
//     let p = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
//     const r = window.loopProps[o]?.product || {},
//         {
//             selling_plan_groups: a
//         } = r,
//         {
//             selling_plan_allocations: s
//         } = n;
//     if (a.map((o => {
//             if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
//                 let l = o.selling_plans[0],
//                     p = s.find((o => Number(o.selling_plan_id) === Number(l.id))) || {};
//                 const {
//                     selling_plan_group_id: r,
//                     price: a,
//                     compare_at_price: d
//                 } = p, c = useCompareAtPrice ? d || n.price : a;
//                 let u = document.querySelector(`#loop-price-${n.id}-${r}`),
//                     g = document.querySelector(`#loop-price-original-${n.id}-${r}`);
//                 if (g && (g.innerHTML = loopFormatMoney(c, !0), g.classList.remove("loop-display-none"), g.style.textDecorationLine = "line-through"), u) {
//                     let o = c;
//                     e.productVariantsFinalValues[t][l.id] && (o = 100 * e.productVariantsFinalValues[t][l.id] * i), u.innerHTML = loopFormatMoney(o, !0);
//                     let p = Math.round((c - o) / c * 100);
//                     const a = document.querySelector(`#loop-discount-badge-${n.id}-${r}`);
//                     let s = `${p>0?p:0}%`,
//                         d = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", s);
//                     a.innerHTML = `${d}`, p > 0 && window.loopPropsUI.displayDiscountBadge ? a.classList.remove("loop-display-none") : a.classList.add("loop-display-none")
//                 }
//                 g && u?.innerHTML == g?.innerHTML && g.classList.add("loop-display-none")
//             }
//         })), p && p.selling_plan_group_id) {
//         const {
//             selling_plan_group_id: o,
//             price: l,
//             compare_at_price: r
//         } = p, a = useCompareAtPrice ? r || n.price : l;
//         let s = document.querySelector(`#loop-price-${n.id}-${o}`),
//             d = document.querySelector(`#loop-price-original-${n.id}-${o}`);
//         if (d && (d.innerHTML = loopFormatMoney(a, !0), d.classList.remove("loop-display-none"), d.style.textDecorationLine = "line-through"), s) {
//             let l = a;
//             e.productVariantsFinalValues[t][p.selling_plan_id] && (l = 100 * e.productVariantsFinalValues[t][p.selling_plan_id] * i), s.innerHTML = loopFormatMoney(l, !0);
//             let r = Math.round((a - l) / a * 100);
//             const d = document.querySelector(`#loop-discount-badge-${n.id}-${o}`);
//             let c = `${r>0?r:0}%`,
//                 u = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", c);
//             d.innerHTML = `${u}`, r > 0 && window.loopPropsUI.displayDiscountBadge ? d.classList.remove("loop-display-none") : d.classList.add("loop-display-none")
//         }
//         d && s?.innerHTML == d?.innerHTML && d.classList.add("loop-display-none")
//     }
//     const d = useCompareAtPrice && n.compare_at_price || n.price,
//         c = e?.productVariantsFinalValues?.[t]?.ONETIME;
//     let u = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time"),
//         g = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time-original"),
//         w = d;
//     if (u && (c && (w = 100 * c * i), u.innerHTML = loopFormatMoney(w, !0)), g) {
//         let o = d;
//         if (g.innerHTML = loopFormatMoney(o, !0), g.classList.remove("loop-display-none"), g.style.textDecorationLine = "line-through", c) {
//             let o = Math.round((d - 100 * c * i) / d * 100);
//             const e = document.querySelector("#loop-discount-badge-onetime");
//             let n = `${o>0?o:0}%`,
//                 t = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", n);
//             e.innerHTML = `${t}`
//         }
//     }
//     u && g && u.innerHTML == g.innerHTML && g.classList.add("loop-display-none")
// }

// function listenLoopCustomEvent() {
//     document.addEventListener("loopPresetAddToCartSuccessEvent", (function(o) {
//         const e = o.detail.productId,
//             n = o.detail.response;
//         window.location.href = "/cart", console.log(`Loop Product ${e} added to cart. Response:`, n)
//     }))
// }

// function removeAllEventListenersLoop(o) {
//     const e = o.cloneNode(!0);
//     return o.parentNode.replaceChild(e, o), e
// }

// function overrideAddToCartButtonLoop(o, e) {
//     document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
//         let n = o.querySelectorAll("button[type=submit]");
//         0 === n.length && (n = o.querySelectorAll("button")), n.forEach((n => {
//             (n = removeAllEventListenersLoop(n)).addEventListener("click", (n => {
//                 const t = o.getAttribute("data-loop-product-id"),
//                     l = document.querySelector(PRODUCT_QUANTITY_SELECTOR);
//                 loopHandleAddToCart(n, t, l?.value, e)
//             }))
//         }))
//     }))
// }
// async function applyShopifyDiscountLoop(o) {
//     try {
//         const e = `${window?.Shopify?.routes?.root}discount/${o}`;
//         await fetch(e, {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json"
//             }
//         })
//     } catch (o) {
//         enableAddToCartBtnLoop(productId)
//     }
// }
// async function createBundleTransaction(o) {
//     try {
//         const e = await fetch(CREATE_BUNDLE_TRANSACTION_API, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json"
//             },
//             body: JSON.stringify(o)
//         });
//         return (await e.json()).loopBundleGuid
//     } catch (o) {
//         throw console.error("createBundleTransaction", o), o
//     }
// }

// function hideOneTimePurchaseOptionLoop(o) {
//     document.querySelectorAll(`form[data-loop-product-id="${o}"]`).forEach((o => {
//         o.querySelectorAll(".loop-one-time-purchase-option").forEach((o => {
//             o.classList.add("loop-display-none")
//         }))
//     }))
// }

// function disableAddToCartBtnLoop(o) {
//     document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
//         o.querySelectorAll("button").forEach((o => {
//             o.disabled = !0
//         }))
//     }))
// }

// function enableAddToCartBtnLoop(o) {
//     document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
//         o.querySelectorAll("button").forEach((o => {
//             o.disabled = !1
//         }))
//     }))
// }

// function createBundleTransactionPayload(o, e, n) {
//     const t = window.loopProps[o].selectedVariantId,
//         l = window.loopProps[o].productBundleData;
//     let i = null,
//         p = {};
//     if (n) {
//         let o = l?.productVariantDiscountMapping?.[t]?.find((o => "SUBSCRIPTION" === o.purchaseType));
//         o && (p = o, i = o.bundleDiscountId)
//     } else {
//         let o = l?.productVariantDiscountMapping?.[t]?.find((o => "SUBSCRIPTION" !== o.purchaseType));
//         o && (p = o, i = o.bundleDiscountId)
//     }
//     return i ? {
//         payload: {
//             bundleId: l.bundleId,
//             bundleVariantId: l?.productVariantMapping?.[t],
//             bundleDiscountId: i,
//             sellingPlanId: l?.productVariantSellingPlanMapping?.[n],
//             productsQuantity: Number(e)
//         },
//         bundleVariantDiscount: p
//     } : {
//         payload: null,
//         bundleVariantDiscount: null
//     }
// }
// async function handleBundleTransaction(o, e, n) {
//     try {
//         const {
//             payload: t,
//             bundleVariantDiscount: l
//         } = createBundleTransactionPayload(o, e, n), i = await createBundleTransaction(t);
//         return i || enableAddToCartBtnLoop(o), {
//             bundleTransactionId: i,
//             bundleVariantDiscount: l
//         }
//     } catch (e) {
//         enableAddToCartBtnLoop(o)
//     }
// }

// function getSelectedSellingPlanLoop(o) {
//     let e = null;
//     return document.querySelectorAll(`form[data-loop-product-id="${o}"]`).forEach((o => {
//         const n = o.querySelector('input[name="selling_plan"]');
//         n?.value && (e = Number(n.value))
//     })), e
// }
// async function getBundleDiscountAttributesLoop() {
//     const o = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`,
//         e = await (await fetch(o)).json(),
//         n = e.attributes?._loopBundleDiscountAttributes ? JSON.parse(e.attributes._loopBundleDiscountAttributes) : {},
//         t = new Set(e.items.map((o => o.properties?._bundleId)).filter((o => o)));
//     return Object.keys(n).filter((o => t.has(o))).reduce(((o, e) => (o[e] = n[e], o)), {})
// }
// async function createAddToCartPayloadLoop(o, e, n, t, l, i) {
//     const p = {
//             items: [],
//             attributes: {
//                 _loopBundleDiscountAttributes: {}
//             }
//         },
//         r = await getBundleDiscountAttributesLoop(),
//         a = {};
//     a[o] = {
//         discountType: e.bundleDiscountType,
//         discountValue: e.bundleDiscountValue,
//         discountComputedValue: e ? n ? e.spbpDiscount[n] * l : e.bundleDiscountComputedValue * l : 0
//     }, p.attributes._loopBundleDiscountAttributes = JSON.stringify({
//         ...r,
//         ...a
//     });
//     const s = i.mapping?.[t].childProducts ?? bundleVariants[t].childProducts;
//     return s?.length && s.forEach((e => {
//         const t = {
//             id: e.childVariantId,
//             quantity: e.quantity * l,
//             selling_plan: n,
//             properties: {
//                 _bundleId: o,
//                 _isPresetBundleProduct: !0
//             }
//         };
//         i.showBundleName ? t.properties.bundleName = i?.loopBundleName ?? "" : t.properties._bundleName = i?.loopBundleName ?? "", p.items.push(t)
//     })), p
// }
// async function shopifyAddToCartByLoop(o, e) {
//     const n = `${window.Shopify.routes.root}cart/add.js`;
//     fetch(n, {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json"
//         },
//         body: JSON.stringify(o)
//     }).then((o => o.json())).then((async o => {
//         await dispatchLoopAddCartEvent(e, o, null)
//     })).catch((o => {
//         console.error("shopifyAddToCartByLoop", o), enableAddToCartBtnLoop(e)
//     }))
// }
// async function loopHandleAddToCart(o, e, n = 1, t) {
//     o.preventDefault(), o.stopPropagation(), disableAddToCartBtnLoop(e);
//     const l = window.loopProps[e].selectedVariantId;
//     if (!t[l].allowCheckout) return console.warn("cannot checkout bundle product"), void disableAddToCartBtnLoop(e);
//     const i = window.loopProps[e].productBundleData;
//     let p = getSelectedSellingPlanLoop(e);
//     const {
//         bundleTransactionId: r,
//         bundleVariantDiscount: a
//     } = await handleBundleTransaction(e, n, p);
//     if (!r) return;
//     const s = await createAddToCartPayloadLoop(r, a, p, l, n, i);
//     await shopifyAddToCartByLoop(s, e)
// }
// async function dispatchLoopAddCartEvent(o, e, n) {
//     const t = new CustomEvent("loopPresetAddToCartSuccessEvent", {
//         detail: {
//             productId: o,
//             response: e
//         }
//     });
//     document.dispatchEvent(t)
// }

// function updatePrepaidPriceInUILoop({
//     productId: o
// }) {
//     const e = window.loopProps[o].prepaidSellingPlans;
//     if (!window.loopProps[o]?.prepaidSellingPlans) return;
//     let n = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
//         t = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
//     const l = window.loopProps[o]?.product || {},
//         {
//             selling_plan_groups: i
//         } = l,
//         {
//             selling_plan_allocations: p
//         } = n;
//     if (i.map((o => {
//             if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
//                 let t = o.selling_plans[0];
//                 if (!e[t.id] || !e[t.id]?.isPrepaidV2) return;
//                 e[t.id];
//                 let l = p.find((o => Number(o.selling_plan_id) === Number(t.id))) || {};
//                 const {
//                     selling_plan_group_id: i,
//                     per_delivery_price: r
//                 } = l;
//                 let a = document.querySelector(`#loop-price-${n.id}-${i}`);
//                 a && (a.innerHTML = loopFormatMoney(r, !0))
//             }
//         })), t && t.selling_plan_group_id) {
//         const {
//             selling_plan_group_id: o,
//             per_delivery_price: l
//         } = t;
//         if (!e[t.selling_plan_id] || !e[t.selling_plan_id]?.isPrepaidV2) return;
//         e[t.selling_plan_id];
//         let i = document.querySelector(`#loop-price-${n.id}-${o}`);
//         i && (i.innerHTML = loopFormatMoney(l, !0))
//     }
// }

// function hideDifferentVariantSellingPlansLoop(o) {
//     o.variants.forEach((o => {
//         var e = o.selling_plan_allocations.map((o => o.selling_plan_id.toString()));
//         o.selling_plan_allocations.forEach((n => {
//             const t = document.querySelector(`#loop-select-${o.id}-${n.selling_plan_group_id}`);
//             if (t) {
//                 t.querySelectorAll("option.loop-selling-plan-selector-option").forEach((function(o) {
//                     e.includes(o.value) || o.remove()
//                 }))
//             }
//         }))
//     }))
// }
// window.loopPurchaseChoice = window.loopPurchaseChoice || {}, window.loopHasInitializedDefaults = window.loopHasInitializedDefaults || {};



"use strict";
const APP_ID = "5284869",
    CREATE_BUNDLE_TRANSACTION_API = "https://api-service.loopwork.co/bundleTransaction",
    FILTER_BUNDLE_SP_API = "https://apiv2.loopwork.co/bundleStorefront/filterBundleSellingPlanIds",
    GET_PRODUCT_BUNDLE_DATA_API = "https://apiv2.loopwork.co/bundleStorefront/getChildVariants?id=",
    PRODUCT_QUANTITY_SELECTOR = ".quantity__input",
    GET_PREPAID_SELLING_PLAN_DATA_URL = "https://api.loopwork.co/api/merchant/sellingPlanGroups/sellingPlansWithDetails?shopifyIds=",
    productDataClass = "loopProductQuickJson",
    loopSubscriptionContainerId = "loop-subscription-container",
    oneTimePurchaseOptionClass = "loop-one-time-purchase-option",
    subscriptionGroupClass = "loop-subscription-group",
    purchaseOptionName = "loop_purchase_option",
    sellingPlanSelectorClass = "loop-selling-plan-selector",
    useCompareAtPrice = !0;

// [PATCH] Remember the last selected frequency (selling plan) per product so it survives variant changes
window.loopLastSellingPlan = window.loopLastSellingPlan || {};

// [PATCH] Pick the remembered selling plan for the given variant + group (falls back to the first plan),
// and sync the variant's frequency dropdown to match
function pickSellingPlanAllocationLoop(productId, variant, groupId) {
    const allocs = (variant?.selling_plan_allocations || []).filter((a => a.selling_plan_group_id === groupId));
    if (!allocs.length) return {};
    const remembered = window.loopLastSellingPlan[productId];
    const chosen = (remembered && allocs.find((a => String(a.selling_plan_id) === String(remembered)))) || allocs[0];
    const container = getLoopSubscriptionContainer(productId);
    const select = container && container.querySelector(`#loop-select-${variant.id}-${groupId}`);
    select && (select.value = String(chosen.selling_plan_id));
    return chosen
}
async function initLoopWidget(o) {
    try {
        log(`start application: ${o}`);
        const e = getLoopProductData(o);
        setupLoopDomListeners(o), initializeWindowLoopProps();
        const n = getLoopSellingPlanGroups(e?.selling_plan_groups);
        e.selling_plan_groups = n;
        const t = getLoopProductVariants(e.variants, n);
        e.variants = t, window.loopProps[o] = {
            product: e
        }, await setLoopUIProperties(Shopify.shop), await processLoopBundleProduct(o), await getLoopBundleSpgs(o), showSellingPlanFieldsetLoop(o), showLoopPurchaseOptionsLabel(o), initializeLoopUI(e), listenLoopCustomEvent(), hideDifferentVariantSellingPlansLoop(e), displayLoopWidget(o), observeFormChangesLoop(e)
    } catch (o) {
        logError(o)
    }
}

function setupLoopDomListeners(o) {
    log(`setup dom listeners for ${o}`);
    const e = getLoopSubscriptionContainer(o),
        n = e.querySelectorAll(`.${oneTimePurchaseOptionClass}`),
        t = e.querySelectorAll(`.${subscriptionGroupClass}`),
        l = e.querySelectorAll(`input[name=${purchaseOptionName}]`),
        i = e.querySelectorAll(`.${sellingPlanSelectorClass}`);
    for (const o of n) o.addEventListener("click", clickOnSellingPlanGroupContainerLoop);
    for (const o of t) o.addEventListener("click", clickOnSellingPlanGroupContainerLoop);
    for (const o of l) o.addEventListener("click", changeInSellingPlanGroupLoop);
    for (const o of i) o.addEventListener("change", changeInDeliveryOptionLoop);
    log(`setup dom listeners complete for ${o}`)
}

function initializeWindowLoopProps() {
    window.loopProps || (window.loopProps = {})
}

function getLoopSellingPlanGroups(o) {
    return Array.isArray(o) ? o.filter((o => o.app_id === APP_ID)) : []
}

function getLoopProductVariants(o, e) {
    const n = new Set(e.map((o => o.id)));
    return o.map((o => ({
        ...o,
        selling_plan_allocations: o.selling_plan_allocations.filter((o => n.has(o.selling_plan_group_id)))
    })))
}
async function setLoopUIProperties(o) {
    const e = await fetchLoopUIProperties(o);
    window.loopPropsUI = {
        ...e
    }
}
async function fetchLoopUIProperties(o) {
    log(`fetch loop subscription UI props: ${o}`);
    const e = `https://d217z8zw4dqir.cloudfront.net/${o}.json`,
        n = await fetch(e);
    return await n.json() ?? {}
}

function showSellingPlanFieldsetLoop(o) {
    const e = getLoopSubscriptionContainer(o).querySelector("#loop-selling-plan-fieldset");
    e && e.classList.remove("loop-display-none", "loop-display-none-by-variant")
}

function showLoopPurchaseOptionsLabel(o) {
    const e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
    if (e)
        for (const o of e) o.classList.remove("loop-display-none", "loop-display-none-by-variant")
}

function initializeLoopUI(o) {
    let e = getVariantIdFromURLLoop(o.variants);
    e || (e = getFirstAvailableVariantVariantIdLoop(o.id)), loopInit({
        productId: o.id,
        product: o,
        variantId: e
    })
}

function getVariantIdFromURLLoop(o) {
    const e = document.URL,
        n = new URL(e).searchParams.get("variant") || "";
    return new Set(o?.map((o => o.id))).has(Number(n)) ? n : null
}

function getFirstAvailableVariantVariantIdLoop(o) {
    const e = getLoopProductData(o),
        n = e?.variants.find((o => o.available)),
        t = n?.id;
    return t
}

function displayLoopWidget(o) {
    const e = getLoopSubscriptionContainer(o);
    e && e.classList.remove("loop-display-none")
}

function observeFormChangesLoop(o) {
    document.querySelectorAll("form").forEach((e => {
        const n = e.querySelector('[name="id"]'),
            t = e.querySelector('[name="loop_variant_id"]');
        t && n?.value && (t.value = n.value);
        const l = new Set(o?.variants?.map((o => o.id)));
        if (n?.value && l.has(Number(n?.value))) {
            const l = {
                attributes: !0,
                childList: !0,
                subtree: !0
            };
            new MutationObserver(((e, l) => {
                const i = n?.value ?? "";
                i && t && i !== (t?.value ?? "") && (t.value = i, loopVariantChanged({
                    loopProduct: o,
                    variantId: i
                }))
            })).observe(e, l)
        }
    }))
}
const loopPriceSelectors = [".price:not(.price--on-sale) .price__regular .price-item--regular", ".price.price--on-sale .price__sale .price-item--sale", ".product-single__prices .product__price:not(.product__price--compare)", ".product-pricing .product--price .price--main .money", "[data-zp-product-discount-price]", ".product-single__header .product__price", ".modal_price .current_price", ".product-area__col--price .current-price.theme-money", '[data-product-type="price"][data-pf-type="ProductPrice"]', ".product__price .fs-heading-4-base[data-price]", "#product-price .money[data-product-price]", "#ProductPrice", ".product-single__price", ".price:not(.price--on-sale) span.price-item--regular", ".product-price .price .money:not(.original)", ".price-box #price .price", ".product__price span[data-product-price]", ".product-form--price-wrapper .product-form--price", ".product-page--pricing--variant-price #price-field", ".price-reviews .product-price"],
    arrToInstanceCountObjLoop = o => o.reduce(((o, e) => (o[e] = (o[e] || 0) + 1, o)), {});

function findSelectedVariantLoop(o, e) {
    const n = getProductFromLoopProps(o) || getLoopProductData(o);
    return findVariantByIdLoop(n, determineSelectedVariantIdLoop(e, o, n))
}

function getProductFromLoopProps(o) {
    return window.loopProps?.[o]?.product
}

function determineSelectedVariantIdLoop(o, e, n) {
    return o || (window.loopProps?.[e]?.selectedVariantId ? window.loopProps[e].selectedVariantId : n.variants?.[0]?.id)
}

function findVariantByIdLoop(o, e) {
    return o.variants?.find((o => Number(o.id) === Number(e)))
}

function defaultSelectFirstSellingPlanLoop(o, e) {
    const n = getLoopSubscriptionContainer(e).querySelectorAll("input[name=loop_purchase_option]") || [];
    let t = !0;
    const {
        selling_plan_allocations: l
    } = o, i = l?.map((o => o.selling_plan_group_id)) || [];
    n.forEach((n => {
        Number(n.dataset.variantId) === Number(o.id) && (window.loopProps[e].previousSPGId && i.includes(window.loopProps[e].previousSPGId) ? n.dataset.id == window.loopProps[e].previousSPGId : t) && (t = !1, n.checked = !0, setTimeout((() => {
            if (loopIsTouchDevice()) {
                const {
                    dataset: o
                } = n;
                changeInSellingPlanGroupLoopMobile(o.id, o.name, o.productId)
            }
            n.click()
        }), 300))
    }))
}

function hideLoopPurchaseOptionsLabel(o) {
    const e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
    if (e)
        for (const o of e) o.classList.add("loop-display-none", "loop-display-none-by-variant")
}

function addLoopPurchaseOptionLabelText(o) {
    let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-purchase-options-label");
    e && e.forEach((o => {
        o && (o.innerHTML = `${window.loopPropsUI.loopPurchaseOptionslabel||"Purchase Options"}`)
    }))
}

function addLoopOneTimePurchaseOptionLabelText(o) {
    let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-one-time-purchase-option-label");
    e && e.forEach((o => {
        o && (o.innerHTML = `${window.loopPropsUI.loopOneTimePurchaselabel||"One time Purchase"}`)
    }))
}

function showOneTimePurchaseOptionAtBottomLoop(o) {
    const e = getLoopSubscriptionContainer(o),
        n = e.querySelector("#loop-one-time-purchase-option-at-top"),
        t = e.querySelector("#loop-one-time-purchase-option-at-bottom");
    n && t && n.innerHTML && (t.innerHTML = n.innerHTML, n.innerHTML = "");
    e.querySelectorAll(".loop-subscription-group").forEach((o => {
        o.classList.remove("loop-subscription-group-border-top"), o.classList.add("loop-subscription-group-border-bottom")
    }))
}

function hideEachLabelForPriceLoop() {
    [".loop-subscription-group-price-quantity", ".loop-one-time-purchase-option-price-quantity"].forEach((o => {
        document.querySelectorAll(o).forEach((o => {
            o.classList.add("loop-display-none")
        }))
    }))
}

function displayLoopTooltip(o) {
    const e = getLoopSubscriptionContainer(o),
        n = e.querySelector("#loop-tooltip");
    if (!n) return;
    n.classList.remove("loop-display-none"), updateLoopTooltipContent(e, "#loop-tooltip-label", window.loopPropsUI.subscriptionPopupLabel), updateLoopTooltipContent(e, "#loop-tooltip-description", window.loopPropsUI.subscriptionPopupDescription);
    const t = e.querySelector("#loop-tooltip-label"),
        l = e.querySelector("#loop-tooltip-description");
    t && l && (t.style.fill = window.getComputedStyle(l).color)
}

function updateLoopTooltipContent(o, e, n) {
    const t = o.querySelector(e);
    t && n && (t.innerHTML = n)
}

function hideLoopTooltip(o) {
    const e = getLoopSubscriptionContainer(o).querySelector("#loop-tooltip");
    e && e.classList.add("loop-display-none")
}

function addExtraLoopStyles() {
    if (window && window.loopPropsUI && window.loopPropsUI.style) {
        let o = {
            purchase_option_label: [".loop-purchase-options-label"],
            widget_feildset: [".loop-selling-plan-fieldset"],
            selling_plan_group_container: [".loop-one-time-purchase-option", ".loop-subscription-group"],
            selling_plan_group_label: [".loop-one-time-purchase-option-label", ".loop-subscription-group-label"],
            selling_plan_label: [".loop-selling-plan-selector-label"],
            selling_plan_selector: [".loop-selling-plan-selector"],
            selling_plan_price_label: [".loop-one-time-purchase-option-price-amount", ".loop-subscription-group-price-amount"],
            selling_plan_price_subtitle_label: [".loop-one-time-purchase-option-price-quantity", ".loop-subscription-group-price-quantity"],
            selling_plan_description_label: [".loop-selling-plan-selector-description"],
            selling_plan_discount_badge_style: [".loop-subscription-group-discount-badge"],
            subscription_details_label: [".loop-tooltip-label"],
            subscription_details_popup: [".loop-tooltiptext", ".loop-container-arrow", ".loop-tooltip-description"],
            selling_plan_group_selected: [".loop-selected-selling-plan-group"],
            selling_plan_group_radio: [".loop-subscription-group-radio", ".loop-one-time-purchase-option-radio"]
        };
        const e = ({
                id: o,
                data: e
            }) => {
                if (e) {
                    let o = Object.keys(e),
                        n = "";
                    return o.forEach((o => {
                        let t = e[o];
                        n = ` ${n} ${o}: ${t} !important;`
                    })), n
                }
                return ""
            },
            n = ({
                id: e,
                data: n
            }) => o[e] || [];
        let t = "";
        const {
            style: l
        } = window.loopPropsUI;
        l.map((o => {
            n(o).map((n => {
                t += `\n                 ${n} {\n                     ${e(o)}\n                 }\n             `
            }))
        }));
        let i = document.querySelectorAll(".loop-style");
        i && i.forEach((o => {
            o.innerHTML = `${o.innerHTML}\n                 ${t}\n             `
        }))
    }
    if (window && window.loopPropsUI && window.loopPropsUI.cssClassess) {
        let o = document.querySelectorAll(".loop-style");
        o && o.forEach((o => {
            o.innerHTML = `${o.innerHTML}\n                 ${window.loopPropsUI.cssClassess}\n             `
        }))
    }
}

function hideLoopSellingPlanFieldset(o) {
    const e = getLoopSubscriptionContainer(o).querySelector("#loop-selling-plan-fieldset");
    e && e.classList.add("loop-display-none", "loop-display-none-by-variant")
}

function applyLoopSettings({
    productId: o
}) {
    let e = window.loopProps[o].product;
    const n = findSelectedVariantLoop(o);
    if (window && window.loopPropsUI && !1 === window.loopPropsUI.displayLoopPurchaseOptionLabel && hideLoopPurchaseOptionsLabel(o), window && window.loopPropsUI && window.loopPropsUI.loopPurchaseOptionslabel && addLoopPurchaseOptionLabelText(o), window && window.loopPropsUI && window.loopPropsUI.loopOneTimePurchaselabel && addLoopOneTimePurchaseOptionLabelText(o), window && window.loopPropsUI && window.loopPropsUI.displayOneTimePurchaseOptionAtBottom) {
        showOneTimePurchaseOptionAtBottomLoop(o);
        getLoopSubscriptionContainer(o).querySelectorAll(".loop-one-time-purchase-option").forEach((o => {
            o.addEventListener("click", clickOnSellingPlanGroupContainerLoop)
        }));
        getLoopSubscriptionContainer(o).querySelectorAll("input[name=loop_purchase_option]").forEach((o => {
            o.addEventListener("click", changeInSellingPlanGroupLoop)
        }))
    }
    if (window && window.loopPropsUI && !1 === window.loopPropsUI.displayEachLabelForPrice && hideEachLabelForPriceLoop(), window && window.loopPropsUI && window.loopPropsUI.hidePlanSelectorIfOnlyOne) {
        const {
            availableSellingPlanAllocations: e = []
        } = window.loopProps[o];
        let t = [];
        e.map((o => {
            t.push(o.selling_plan_group_id)
        }));
        let l = arrToInstanceCountObjLoop(t);
        Object.keys(l).forEach((o => {
            if (1 === l[o]) {
                let e = `#loop-selling-plan-container-${n.id}-${o}`,
                    t = document.querySelector(e);
                if (t) {
                    let e = t.querySelector(".loop-selling-plan-selector-label"),
                        l = t.querySelector(`#loop-selling-plan-first-delivery-options-${n.id}-${o}`),
                        i = t.querySelector(".loop-selling-plan-selector");
                    e && e.classList.add("loop-display-none"), l && l.classList.add("loop-display-none"), i && i.classList.add("loop-display-none")
                }
            }
        }))
    }
    if (window && window.loopPropsUI && window.loopPropsUI.showPlanSelectorAsTextIfOnlyOnePlan && !window.loopPropsUI.hidePlanSelectorIfOnlyOne) {
        const {
            availableSellingPlanAllocations: e = []
        } = window.loopProps[o];
        let t = [];
        e.map((o => {
            t.push(o.selling_plan_group_id)
        }));
        let l = arrToInstanceCountObjLoop(t);
        Object.keys(l).forEach((o => {
            if (1 === l[o]) {
                let e = `#loop-selling-plan-first-delivery-options-${n.id}-${o}`,
                    t = document.querySelector(e);
                t && t.classList && t.classList.remove("loop-display-none"), e = `#loop-select-${n.id}-${o}`, t = document.querySelector(e), t && t.classList.add("loop-display-none")
            }
        }))
    }
    if (window && window.loopPropsUI && window.loopPropsUI.hideWholeWidgetIfOnlyOnePlan && e.requires_selling_plan && n.selling_plan_allocations && 1 === n.selling_plan_allocations.length && (hideLoopSellingPlanFieldset(o), hideLoopPurchaseOptionsLabel(o)), window && window.loopPropsUI && window.loopPropsUI.hideRadioButtonIfOnlyOnePlan && e.requires_selling_plan) {
        const {
            availableSellingPlanAllocations: e
        } = window.loopProps[o];
        let n = [];
        e.map((o => {
            n.push(o.selling_plan_group_id)
        }));
        let t = arrToInstanceCountObjLoop(n),
            l = !1;
        if (l = 1 === Object.keys(t).length, l) {
            let e = getLoopSubscriptionContainer(o).querySelectorAll(".loop-subscription-group-radio");
            e && e.forEach((o => {
                o.classList.add("loop-display-none")
            }));
            let n = getLoopSubscriptionContainer(o).querySelectorAll(".loop-subscription-group-selling-plans-container");
            n && n.forEach((o => {
                o.classList.add("loop-left-margin-0")
            }))
        }
    }
    if (addExtraLoopStyles(), window && window.loopPropsUI && window.loopPropsUI.displaySubscriptionPopup && n && n.selling_plan_allocations && n.selling_plan_allocations.length ? displayLoopTooltip(o) : hideLoopTooltip(o), e && e.requires_selling_plan && Array.isArray(n.selling_plan_allocations) && n.selling_plan_allocations.length) {
        let e = `#loop-product-variant-${n.id}`,
            t = getLoopSubscriptionContainer(o).querySelector(e);
        if (window && window.loopPropsUI && window.loopPropsUI.displayOneTimePurchaseOptionAtBottom) {
            let o = ".loop-subscription-group",
                e = t.querySelectorAll(o);
            if (e && e.length) {
                let o = e[e.length - 1];
                o.style.borderBottom = "0", o.classList.remove("loop-subscription-group-border-bottom")
            }
        } else {
            let o = ".loop-subscription-group",
                e = t.querySelectorAll(o);
            if (e && e.length) {
                let o = e[0];
                o.style.borderTop = "0", o.classList.remove("loop-subscription-group-border-top")
            }
        }
    }
    if (window && window.loopPropsUI && window.loopPropsUI.displayDiscountBadge) displayLoopDiscountBadge({
        productId: o
    });
    else {
        let o = document.querySelectorAll(".loop-subscription-group-discount-badge");
        o && o.forEach((o => {
            o && o.classList.add("loop-display-none")
        }))
    }
    if (window && window.loopPropsUI && window.loopPropsUI.translationData) {
        let o = window.loopPropsUI.translationData || {},
            e = {
                widget_price_label_text: [".loop-one-time-purchase-option-price-quantity", ".loop-subscription-group-price-quantity"]
            };
        Object.keys(e).forEach((n => {
            if (o && o[n]) {
                e[n].map((e => {
                    let t = document.querySelectorAll(e);
                    t && t.forEach((e => {
                        e.innerText = o[n]
                    }))
                }))
            }
        }))
    }
}

function clickOnSellingPlanGroupContainerLoop(o) {
    const e = o.target.closest(".loop-subscription-group") || o.target.closest(".loop-one-time-purchase-option");
    if (!e) return;
    const n = e.querySelector('input[type="radio"]'),
        t = window.loopProps[n.dataset.productId]?.sellingPlanGroupId;
    n?.dataset?.id !== t && n.click()
}

function loopVariantChanged({
    loopProduct: o,
    variantId: e
}) {
    loopInit({
        productId: o.id,
        product: JSON.parse(JSON.stringify(o)),
        variantId: e
    })
}

function checkVariantsSellingPlanAllocationLoop(o, e) {
    o?.selling_plan_allocations?.length > 0 ? (showSellingPlanFieldsetLoop(e), showLoopPurchaseOptionsLabel(e)) : (hideLoopSellingPlanFieldset(e), hideLoopPurchaseOptionsLabel(e))
}

function defaultSelectOneTimePurchaseOptionLoop(o, e) {
    const n = getLoopSubscriptionContainer(e).querySelector(`#loop-one-time-purchase-${e}`);
    if (n) {
        if (n.checked = !0, n.click(), loopIsTouchDevice()) {
            const {
                dataset: o
            } = n;
            changeInSellingPlanGroupLoopMobile(o.id, o.name, o.productId)
        }
    } else defaultSelectFirstSellingPlanLoop(o, e)
}

function loopInit({
    productId: o,
    product: e,
    variantId: n
}) {
    updateLoopProperties({
        product: e,
        productId: o,
        variantId: n
    });
    const t = findSelectedVariantLoop(o, n);
    toggleVariantDisplayLoop(e, t.id), checkVariantsSellingPlanAllocationLoop(t, o), applyLoopSettings({
        productId: o
    }), applyDefaultSelectionBasedOnLoopSettings(t, o), hideLoopBundleSPG(o)
}

function toggleVariantDisplayLoop(o, e) {
    o.variants.forEach((o => {
        const n = o.id === e ? "block" : "none";
        document.querySelector(`#loop-product-variant-${o.id}`).style.display = n
    }))
}

function applyDefaultSelectionBasedOnLoopSettings(o, e) {
    if (window.loopHasInitializedDefaults[e] && window.loopPurchaseChoice[e]) {
        return void("subscription" === window.loopPurchaseChoice[e] ? defaultSelectFirstSellingPlanLoop(o, e) : defaultSelectOneTimePurchaseOptionLoop(o, e))
    }
    const n = window.loopPropsUI?.byDefaultChooseSubscriptionOption;
    n ? (defaultSelectFirstSellingPlanLoop(o, e), window.loopPurchaseChoice[e] = "subscription") : (defaultSelectOneTimePurchaseOptionLoop(o, e), window.loopPurchaseChoice[e] = "one_time"), window.loopHasInitializedDefaults[e] = !0
}

function updateSelectDropDownDefaultValuesLoop({
    productId: o,
    variant: e,
    sellingPlanGroupId: n
}) {
    const t = window.loopProps[o].product.selling_plan_groups;
    Array.isArray(t) && t.length && t.forEach((o => {
        n !== o.id && resetSelectDropdownLoop(e.id, o.id)
    }))
}

function resetSelectDropdownLoop(o, e) {
    const n = document.getElementById(`loop-select-${o}-${e}`);
    n && (n.options[0].selected = !0)
}

function changeInSellingPlanGroupLoopMobile(o, e, n) {
    window.loopPurchaseChoice || (window.loopPurchaseChoice = {}), window.loopPurchaseChoice[n] = "loop-one-time-purchase" === o ? "one_time" : "subscription", window.loopProps || (window.loopProps = {}), window.loopProps[n] || (window.loopProps[n] = {}), window.loopProps[n].previousSPGId = o;
    const t = findSelectedVariantLoop(n, window.loopProps[n].selectedVariantId);
    // [PATCH] use the remembered frequency instead of always the first plan
    let i = pickSellingPlanAllocationLoop(n, t, o),
        p = i.selling_plan_id;
    updateLoopProperties({
        productId: n,
        variantId: t.id,
        sellingPlanGroupId: o,
        sellingPlanGroupName: e,
        sellingPlanId: p,
        sellingPlan: i
    }), updateSelectDropDownDefaultValuesLoop({
        productId: n,
        variant: t,
        sellingPlanGroupId: o
    }), updatePriceInParentElementsLoop({
        productId: n
    }), updateLoopSellingPlanDescriptionUI({
        productId: n
    }), displayLoopDiscountBadge({
        productId: n
    }), updateCartButtonTextLoop({
        productId: n
    }), updatePriceInUILoop({
        productId: n
    }), updatePrepaidPriceInUILoop({
        productId: n
    }), applyLoopBundleDiscount(n), checkAllowCheckoutIfBundle(n);
    let r = getLoopSubscriptionContainer(n).querySelectorAll(".loop-selected-selling-plan-group");
    if (r && r.forEach((o => {
            o && o.classList.remove("loop-selected-selling-plan-group")
        })), "loop-one-time-purchase" === o) {
        let o = getLoopSubscriptionContainer(n).querySelectorAll(".loop-one-time-purchase-option");
        o && o.forEach((o => {
            o.classList.add("loop-selected-selling-plan-group")
        }))
    } else {
        let e = `#loop-${t.id}-${o}`,
            l = getLoopSubscriptionContainer(n).querySelector(e);
        l && l.classList.add("loop-selected-selling-plan-group")
    }
}

function changeInSellingPlanGroupLoop(o) {
    let e = o.target.dataset.id,
        n = o.target.dataset.name,
        t = o.target.dataset.productId;
    window.loopPurchaseChoice || (window.loopPurchaseChoice = {}), window.loopPurchaseChoice[t] = "loop-one-time-purchase" === e ? "one_time" : "subscription", window.loopProps || (window.loopProps = {}), window.loopProps[t] || (window.loopProps[t] = {}), window.loopProps[t].previousSPGId = e;
    const l = findSelectedVariantLoop(t, window.loopProps[t].selectedVariantId);
    // [PATCH] use the remembered frequency instead of always the first plan
    let p = pickSellingPlanAllocationLoop(t, l, e),
        r = p.selling_plan_id;
    updateLoopProperties({
        productId: t,
        variantId: l.id,
        sellingPlanGroupId: e,
        sellingPlanGroupName: n,
        sellingPlanId: r,
        sellingPlan: p
    }), updateSelectDropDownDefaultValuesLoop({
        productId: t,
        variant: l,
        sellingPlanGroupId: o.target.dataset.id
    }), updatePriceInParentElementsLoop({
        productId: t
    }), updateLoopSellingPlanDescriptionUI({
        productId: t
    }), displayLoopDiscountBadge({
        productId: t
    }), updateCartButtonTextLoop({
        productId: t
    }), updatePriceInUILoop({
        productId: t
    }), updatePrepaidPriceInUILoop({
        productId: t
    }), applyLoopBundleDiscount(t), checkAllowCheckoutIfBundle(t);
    let a = getLoopSubscriptionContainer(t).querySelectorAll(".loop-selected-selling-plan-group");
    if (a && a.forEach((o => {
            o && o.classList.remove("loop-selected-selling-plan-group")
        })), "loop-one-time-purchase" === e) {
        let o = getLoopSubscriptionContainer(t).querySelectorAll(".loop-one-time-purchase-option");
        o && o.forEach((o => {
            o.classList.add("loop-selected-selling-plan-group")
        }))
    } else {
        let o = `#loop-${l.id}-${e}`,
            n = getLoopSubscriptionContainer(t).querySelector(o);
        n && n.classList.add("loop-selected-selling-plan-group")
    }
}

function changeInDeliveryOptionLoop(o) {
    let e = o.target.value,
        n = o.target.dataset.productId;
    // [PATCH] remember the frequency the shopper picked
    window.loopLastSellingPlan[n] = e;
    updateLoopProperties({
        productId: n,
        sellingPlanId: e
    }), updatePriceInParentElementsLoop({
        productId: n
    }), updateLoopSellingPlanDescriptionUI({
        productId: n
    }), displayLoopDiscountBadge({
        productId: n
    }), updatePriceInUILoop({
        productId: n
    }), updatePrepaidPriceInUILoop({
        productId: n
    }), applyLoopBundleDiscount(n), checkAllowCheckoutIfBundle(n)
}

function displayLoopDiscountBadge({
    productId: o
}) {
    const e = window.loopProps[o]?.prepaidSellingPlans || {},
        n = findSelectedVariantLoop(o),
        {
            selling_plan_groups: t
        } = window.loopProps[o].product;
    window && window.loopProps && window.loopPropsUI.displayDiscountBadge ? t.map((t => {
        const {
            selling_plans: l
        } = t, i = l[0];
        let p = e[i.id]?.deliveriesPerBillingCycle || 1,
            r = [];
        l.map((o => {
            const t = e[o.id]?.deliveriesPerBillingCycle || 1,
                {
                    price_adjustments: l
                } = o;
            let i = l.length ? l[0] : {};
            r.push({
                value: i.value / t,
                value_type: i.value_type,
                amount: "fixed_amount" === i.value_type ? i.value : "price" === i.value_type ? Number(n.price) - Number(i.value / t) : Number(n.price) * i.value / 100
            })
        }));
        let a = r.reduce(((o, e) => o.amount > e.amount ? o : e));
        if (p > 1) {
            const o = n.selling_plan_allocations.find((o => o.selling_plan_group_id === t.id));
            let i = l.find((e => e.id === Number(o.selling_plan_id))) || {};
            a = i.price_adjustments[0], p = e[i.id]?.deliveriesPerBillingCycle || 1
        }
        let s = `#loop-discount-badge-${n.id}-${t.id}`,
            d = getLoopSubscriptionContainer(o).querySelector(s);
        if (window.loopProps[o] && t.id === window.loopProps[o].sellingPlanGroupId) {
            let n = l.find((e => e.id === Number(window.loopProps[o].sellingPlanId))) || {};
            a = n.price_adjustments[0], p = e[n.id]?.deliveriesPerBillingCycle || 1
        }
        if (d) {
            let o = "";
            if (a && "fixed_amount" === a.value_type) o = loopFormatMoney(a.value, !0);
            else if (a && "percentage" === a.value_type) o = `${a.value}%`;
            else if (a && "price" === a.value_type)
                if (p > 1) {
                    const e = (Number(n.price) - Number(a.value / p)) / Number(n.price) * 100;
                    o = `${Math.round(e>0?e:0)}%`
                } else o = loopFormatMoney(Number(n.price) - Number(a.value / p) > 0 ? Number(n.price) - Number(a.value / p) : 0, !0);
            let e = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", o);
            d.innerHTML = `${e}`, !a?.value && !Number(a?.value) || a && "price" === a.value_type && Math.round(Number(n.price) - Number(a.value / p)) <= 0 ? d.classList.add("loop-display-none") : d.classList.remove("loop-display-none")
        }
    })) : t.map((o => {
        let e = `#loop-discount-badge-${n.id}-${o.id}`,
            t = document.querySelector(e);
        t && t.classList.add("loop-display-none")
    }))
}

function calculateCurrentSellingPlanLoop({
    productId: o,
    availableSellingPlanAllocations: e
}) {
    const n = window.loopProps[o],
        {
            sellingPlanId: t,
            sellingPlanGroupId: l
        } = n;
    return e.find((o => o.selling_plan_group_id === l && (!t || Number(o.selling_plan_id) === Number(t)))) || {}
}

function updateLoopProperties({
    product: o,
    productId: e,
    variantId: n,
    sellingPlanGroupId: t,
    sellingPlanGroupName: l,
    sellingPlanId: i
}) {
    let p = getLoopSubscriptionContainer(e).querySelector("#loop-selling-plan-fieldset");
    n && (Number(n) !== Number(p.dataset.selectedVariantId) && (p.dataset.sellingPlanGroupId = "", p.dataset.sellingPlanGroupName = "", p.dataset.sellingPlanId = ""), p.dataset.selectedVariantId = n), t && (p.dataset.sellingPlanGroupId = t), l && (p.dataset.sellingPlanGroupName = l), o && (p.dataset.product = JSON.stringify(o)), i ? p.dataset.sellingPlanId = i : "loop-one-time-purchase" === t && (p.dataset.sellingPlanId = "", p.dataset.sellingPlan = {}, p.dataset.sellingPlan = {}), window.loopProps || (window.loopProps = {}, window.loopProps[e] = {
        product: o,
        productId: e
    });
    const r = window.loopProps[e].productBundleData,
        a = window.loopProps[e].previousSPGId,
        s = window.loopProps[e].bundleSPGS,
        d = window.loopProps[e].nonBundleSPGS,
        c = window.loopProps[e].prepaidSellingPlans,
        u = window.loopProps[e].product;
    window.loopProps[e] = {
        ...p.dataset,
        productId: e
    }, window.loopProps[e].productBundleData = r, window.loopProps[e].previousSPGId = a, window.loopProps[e].prepaidSellingPlans = c, window.loopProps[e].product = u, window.loopProps[e].bundleSPGS = s, window.loopProps[e].nonBundleSPGS = d;
    let g = findSelectedVariantLoop(e),
        w = g && Array.isArray(g.selling_plan_allocations) ? g.selling_plan_allocations : [];
    window.loopProps[e].availableSellingPlanAllocations = w, window.loopProps[e].variant = g;
    let P = calculateCurrentSellingPlanLoop({
            availableSellingPlanAllocations: w,
            productId: e
        }),
        L = P.selling_plan_id || "";
    window.loopProps[e].sellingPlan = P;
    let f = w.find((o => {
        if (L && Number(o.selling_plan_id) === Number(L)) return !0
    }));
    window.loopProps[e].sellingPlanAllocation = f;
    const {
        selling_plan_groups: _
    } = window.loopProps[e].product;
    window.loopProps[e].sellingPlanDefination = {}, window.loopProps[e].sellingPlanPriceAdjustments = [], _ && Array.isArray(_) && _.map((o => {
        if (o.id === window.loopProps[e].sellingPlanGroupId) {
            const {
                selling_plans: n
            } = o;
            n.map((o => {
                o.id === Number(window.loopProps[e].sellingPlanId) && (window.loopProps[e].sellingPlanDefination = o, window.loopProps[e].sellingPlanPriceAdjustments = o.price_adjustments)
            }))
        }
    }));
    let y = getLoopSubscriptionContainer(e).querySelector('[name="selling_plan"]');
    y && (y.value = L), document.querySelectorAll(`form[data-loop-product-id="${e}"]`).forEach((o => {
        const e = o.querySelectorAll('input[name="selling_plan"]');
        e.length && e.forEach((o => {
            o.remove()
        }));
        const n = document.createElement("input");
        n.type = "hidden", n.name = "selling_plan", n.value = L, o.appendChild(n)
    }))
}

function updateCartButtonTextLoop({
    productId: o
}) {
    const e = document.querySelector(`[data-loop-product-id="${o}"]`) || document,
        n = determineOneTimeOrderLoop(o),
        t = getAddToCartButtonLoop(e);
    if (!t) return;
    updateButtonInnerHTMLLoop(t, getButtonTextLoop(n, o))
}

function determineOneTimeOrderLoop(o) {
    const e = window?.loopProps[o]?.sellingPlanGroupId;
    return !e || "loop-one-time-purchase" === e
}

function getAddToCartButtonLoop(o) {
    let e = null;
    return ["button[type='submit'][name='add']", "button[type='button'][name='add']"].map((n => {
        e || (e = o.querySelector(n)), e || (e = document.querySelector(n))
    })), e
}

function getButtonTextLoop(o, e) {
    return o ? window.loopProps[e].variant.available ? window?.loopPropsUI?.translationData?.widget_add_to_cart_button_for_one_time_purchase || "Add to cart" : window?.loopPropsUI?.translationData?.widget_out_of_stock_text || "Out of Stock" : window?.loopPropsUI?.translationData?.widget_add_to_cart_button_for_subscription || "Add subscription to cart"
}

function updateButtonInnerHTMLLoop(o, e) {
    o.firstElementChild ? o.firstElementChild.innerHTML = e : o.innerHTML = e
}

function loopFormatMoney(o, e) {
    if (Shopify.locale && Shopify.country && Shopify.currency.active) return loopFormatPriceNew(o, Shopify.locale, Shopify.country, Shopify.currency.active);
    let n = loopFormatPrice(o, document.querySelector("#loop-price-money-format").innerText, document.querySelector("#loop-price-money_without_currency-format").innerText);
    return e && (n = n.replace("each", "")), n.trim()
}

function loopFormatPriceNew(o, e, n, t) {
    const l = o / 100;
    return new Intl.NumberFormat(`${e}-${n}`, {
        style: "currency",
        currency: `${t}`
    }).format(l)
}

function loopFormatPrice(o, e, n) {
    const t = o / 100;
    if (e.includes("0.00")) return e.replace("0.00", t.toFixed(2));
    if (e.includes("0,00")) return e.replace("0,00", t.toFixed(2).replace(".", ","));
    if (e.includes("0")) {
        const o = Number(n.replace("0", t)).toFixed(0);
        return e.replace("0", o)
    }
    return e
}

function getSavedPriceLabel(o) {
    if (!Array.isArray(o) || !o.length) return "";
    const e = o[0];
    return "percentage" === e.value_type ? `Save ${e.value}%` : `Save ${loopFormatMoney(e.value,!0)}`
}

function updateLoopSellingPlanDescriptionUI({
    productId: o
}) {
    const e = findSelectedVariantLoop(o),
        n = window.loopProps?.[o];
    if (!n?.sellingPlanGroupId) return;
    const t = n?.sellingPlanDefination?.description || "";
    updateLoopSellingPlanDescriptionElement(document.querySelector(`#loop-selling-plan-description-${e.id}-${n.sellingPlanGroupId}`), t)
}

function updateLoopSellingPlanDescriptionElement(o, e) {
    o && (o.innerHTML = e, e ? o.classList.remove("loop-display-none") : o.classList.add("loop-display-none"))
}

function updatePriceInParentElementsLoop({
    productId: o
}) {
    const e = getCurrentPathLoop(),
        n = window?.loopProps[o]?.product?.handle;
    if (n !== e) return;
    const t = determinePriceLoop(o, findSelectedVariantLoop(o));
    loopPriceSelectors.push(`.loop-product-${o}`), updatePricesInUILoop(t)
}

function determinePriceLoop(o, e) {
    const n = window?.loopProps[o]?.sellingPlanAllocation?.price;
    return loopFormatMoney(n || e.price, !0)
}

function updatePricesInUILoop(o) {}

function updatePriceInUILoop({
    productId: o
}) {
    let e = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
        n = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
    const t = window.loopProps[o]?.product || {},
        {
            selling_plan_groups: l
        } = t,
        {
            selling_plan_allocations: i
        } = e;
    if (l.map((o => {
            if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
                let n = o.selling_plans[0],
                    t = i.find((o => Number(o.selling_plan_id) === Number(n.id))) || {};
                const {
                    selling_plan_group_id: l,
                    per_delivery_price: p
                } = t;
                let r = document.querySelector(`#loop-price-${e.id}-${l}`);
                r && (r.innerHTML = loopFormatMoney(p, !0))
            }
        })), n && n.selling_plan_group_id) {
        const {
            selling_plan_group_id: o,
            per_delivery_price: t
        } = n;
        let l = document.querySelector(`#loop-price-${e.id}-${o}`);
        l && (l.innerHTML = loopFormatMoney(t, !0))
    }
    let p = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time");
    if (p) {
        p.innerHTML = loopFormatMoney(e.price, !0), document.querySelectorAll(".loop-subscription-group-price-amount-original").forEach((o => {
            o.innerHTML = loopFormatMoney(e.price, !0)
        }))
    }
}

function log(o) {
    console.log(o)
}

function logError(o) {
    console.error(o)
}

function initializeLoopData(o) {
    window.LoopSubscriptions || (window.LoopSubscriptions = {}), window.LoopSubscriptions[o] = getLoopProductData(o)
}

function getLoopProductData(o) {
    const e = document.querySelector(`.${productDataClass}-${o}`).textContent;
    return JSON.parse(e)
}

function getLoopSubscriptionContainer(o) {
    return document.querySelector(`#${loopSubscriptionContainerId}-${o}`)
}

function getCurrentPathLoop() {
    const o = window.location.pathname.split("/");
    return o[o.length - 1]
}

function loopIsTouchDevice() {
    return "ontouchstart" in document.documentElement
}
async function getLoopBundleSpgs(o) {
    const e = loopProps[o]?.product?.selling_plan_groups?.flatMap((o => o?.selling_plans?.map((e => ({
            selling_plan_group_id: o.id,
            selling_plan_id: e.id
        }))))) || [],
        n = loopProps[o]?.product?.selling_plan_groups?.flatMap((o => o?.selling_plans.map((o => o.id)))) || [],
        t = {
            domain: window.Shopify.shop,
            sellingPlanIds: n,
            product_shopify_id: o
        },
        l = n.join(","),
        i = `${GET_PREPAID_SELLING_PLAN_DATA_URL}${l}`;
    try {
        const [n, l] = await Promise.all([fetch(FILTER_BUNDLE_SP_API, {
            method: "POST",
            body: JSON.stringify(t),
            headers: {
                "Content-Type": "application/json"
            }
        }), fetch(i, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })]), p = (await n.json()).data;
        let r = [],
            a = [];
        for (const o of e) p.includes(o.selling_plan_id) ? r.push(o.selling_plan_group_id) : a.push(o.selling_plan_group_id);
        window.loopProps[o].bundleSPGS = [...new Set(r)], window.loopProps[o].nonBundleSPGS = [...new Set(a)], hideLoopBundleSPG(o);
        const s = (await l.json()).data;
        window.loopProps[o].prepaidSellingPlans = s?.sellingPlans || null
    } catch (o) {
        console.error("getLoopBundleSpgs", o)
    }
}

function hideLoopBundleSPG(o) {
    if (!window.loopProps?.[o]?.productBundleData?.isBundleProduct) {
        const e = window.loopProps[o],
            n = getLoopSubscriptionContainer(o);
        if (n) {
            const t = e.bundleSPGS;
            t?.length && (t.forEach((o => {
                const e = n.querySelectorAll(`#loop-selling_plan_group-${o}`);
                e?.length && e.forEach((o => {
                    o.classList.add("loop-display-none")
                }))
            })), clickUpdatedSPGLoop(o))
        }
    }
}

function clickUpdatedSPGLoop(o) {
    showSellingPlanFieldsetLoop(o), window && window.loopPropsUI && window.loopPropsUI.displayLoopPurchaseOptionLabel ? showLoopPurchaseOptionsLabel(o) : hideLoopPurchaseOptionsLabel(o);
    const e = window.loopProps[o].selectedVariantId;
    let n = window.loopProps[o].nonBundleSPGS ?? [];
    window.loopProps[o].bundleSPGS;
    const t = window.loopProps[o].product.variants,
        l = getVariantIdFromURLLoop(t) ?? getFirstAvailableVariantVariantIdLoop(o),
        i = (t.find((o => o.id == l)) ?? t[0]).selling_plan_allocations.map((o => o.selling_plan_group_id));
    if (n = n.filter((o => i.includes(o))), 0 !== n.length && window.loopPropsUI.byDefaultChooseSubscriptionOption) {
        showLoopWidget(o);
        const t = n[0];
        getLoopSubscriptionContainer(o).querySelectorAll(`#loop-selling_plan_group-${t}`).forEach((o => {
            o.querySelectorAll(`#loop-allocation-${t}`).forEach((o => {
                o.querySelectorAll(`#loop-${e}-${t}`).forEach((o => {
                    o.click()
                }))
            }))
        }))
    } else 0 === n.length && hideLoopWidget(o), setTimeout((() => defaultSelectOneTimePurchaseOptionLoop(e, o)), 500)
}

function showLoopWidget(o) {
    const e = document.getElementById(`loop-subscription-container-${o}`);
    e && (e.style.display = "block")
}

function hideLoopWidget(o) {
    const e = document.getElementById(`loop-subscription-container-${o}`);
    e && (e.style.display = "none")
}
async function getBundleDataByProductId(o) {
    const e = await fetch(`${GET_PRODUCT_BUNDLE_DATA_API}${o}`);
    return (await e.json()).data
}

function handleBundleWidgetVisibility(o) {
    "SUBSCRIPTION" === window.loopProps[o].productBundleData.purchaseType ? hideOneTimePurchaseOptionLoop(o) : "ONETIME" === window.loopProps[o].productBundleData.purchaseType && (hideLoopSellingPlanFieldset(o), hideLoopPurchaseOptionsLabel(o), defaultSelectOneTimePurchaseOptionLoop(null, o))
}
async function processLoopBundleProduct(o) {
    try {
        const e = await getBundleDataByProductId(o);
        e && (window.loopProps[o].productBundleData = e, e.isBundleProduct && (overrideAddToCartButtonLoop(o, e.mapping), handleBundleWidgetVisibility(o), applyLoopBundleDiscount(o), checkAllowCheckoutIfBundle(o)))
    } catch (o) {
        console.error("processLoopBundleProduct", o)
    }
}

function checkAllowCheckoutIfBundle(o) {
    enableAddToCartBtnLoop(o);
    const e = window.loopProps[o].selectedVariantId;
    if (window.loopProps[o]?.productBundleData?.isBundleProduct) {
        const n = window.loopProps[o].productBundleData.mapping[e],
            t = n?.allowCheckout,
            l = n?.outOfStock;
        if (l) {
            const e = window?.loopPropsUI?.translationData?.widget_out_of_stock_text || "Out of Stock",
                n = getAddToCartButtonLoop(document.querySelector(`[data-loop-product-id="${o}"]`) || document);
            n && setTimeout((() => {
                updateButtonInnerHTMLLoop(n, e)
            }), 500)
        }
        t && !l || disableAddToCartBtnLoop(o)
    }
}

function applyLoopBundleDiscount(o) {
    if (!window.loopProps[o]?.productBundleData?.isBundleProduct) return;
    const e = window.loopProps[o].productBundleData;
    let n = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
        t = window.loopProps[o].selectedVariantId;
    const l = e.productVariantDiscountMapping?.[t];
    if (!l) return;
    const i = window.Shopify.currency.rate;
    let p = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
    const r = window.loopProps[o]?.product || {},
        {
            selling_plan_groups: a
        } = r,
        {
            selling_plan_allocations: s
        } = n;
    if (a.map((o => {
            if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
                let l = o.selling_plans[0],
                    p = s.find((o => Number(o.selling_plan_id) === Number(l.id))) || {};
                const {
                    selling_plan_group_id: r,
                    price: a,
                    compare_at_price: d
                } = p, c = useCompareAtPrice ? d || n.price : a;
                let u = document.querySelector(`#loop-price-${n.id}-${r}`),
                    g = document.querySelector(`#loop-price-original-${n.id}-${r}`);
                if (g && (g.innerHTML = loopFormatMoney(c, !0), g.classList.remove("loop-display-none"), g.style.textDecorationLine = "line-through"), u) {
                    let o = c;
                    e.productVariantsFinalValues[t][l.id] && (o = 100 * e.productVariantsFinalValues[t][l.id] * i), u.innerHTML = loopFormatMoney(o, !0);
                    let p = Math.round((c - o) / c * 100);
                    const a = document.querySelector(`#loop-discount-badge-${n.id}-${r}`);
                    let s = `${p>0?p:0}%`,
                        d = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", s);
                    a.innerHTML = `${d}`, p > 0 && window.loopPropsUI.displayDiscountBadge ? a.classList.remove("loop-display-none") : a.classList.add("loop-display-none")
                }
                g && u?.innerHTML == g?.innerHTML && g.classList.add("loop-display-none")
            }
        })), p && p.selling_plan_group_id) {
        const {
            selling_plan_group_id: o,
            price: l,
            compare_at_price: r
        } = p, a = useCompareAtPrice ? r || n.price : l;
        let s = document.querySelector(`#loop-price-${n.id}-${o}`),
            d = document.querySelector(`#loop-price-original-${n.id}-${o}`);
        if (d && (d.innerHTML = loopFormatMoney(a, !0), d.classList.remove("loop-display-none"), d.style.textDecorationLine = "line-through"), s) {
            let l = a;
            e.productVariantsFinalValues[t][p.selling_plan_id] && (l = 100 * e.productVariantsFinalValues[t][p.selling_plan_id] * i), s.innerHTML = loopFormatMoney(l, !0);
            let r = Math.round((a - l) / a * 100);
            const d = document.querySelector(`#loop-discount-badge-${n.id}-${o}`);
            let c = `${r>0?r:0}%`,
                u = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", c);
            d.innerHTML = `${u}`, r > 0 && window.loopPropsUI.displayDiscountBadge ? d.classList.remove("loop-display-none") : d.classList.add("loop-display-none")
        }
        d && s?.innerHTML == d?.innerHTML && d.classList.add("loop-display-none")
    }
    const d = useCompareAtPrice && n.compare_at_price || n.price,
        c = e?.productVariantsFinalValues?.[t]?.ONETIME;
    let u = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time"),
        g = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time-original"),
        w = d;
    if (u && (c && (w = 100 * c * i), u.innerHTML = loopFormatMoney(w, !0)), g) {
        let o = d;
        if (g.innerHTML = loopFormatMoney(o, !0), g.classList.remove("loop-display-none"), g.style.textDecorationLine = "line-through", c) {
            let o = Math.round((d - 100 * c * i) / d * 100);
            const e = document.querySelector("#loop-discount-badge-onetime");
            let n = `${o>0?o:0}%`,
                t = (window?.loopPropsUI?.discountBadgeText || " ").replace("{discount_value}", n);
            e.innerHTML = `${t}`
        }
    }
    u && g && u.innerHTML == g.innerHTML && g.classList.add("loop-display-none")
}

function listenLoopCustomEvent() {
    document.addEventListener("loopPresetAddToCartSuccessEvent", (function(o) {
        const e = o.detail.productId,
            n = o.detail.response;
        window.location.href = "/cart", console.log(`Loop Product ${e} added to cart. Response:`, n)
    }))
}

function removeAllEventListenersLoop(o) {
    const e = o.cloneNode(!0);
    return o.parentNode.replaceChild(e, o), e
}

function overrideAddToCartButtonLoop(o, e) {
    document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
        let n = o.querySelectorAll("button[type=submit]");
        0 === n.length && (n = o.querySelectorAll("button")), n.forEach((n => {
            (n = removeAllEventListenersLoop(n)).addEventListener("click", (n => {
                const t = o.getAttribute("data-loop-product-id"),
                    l = document.querySelector(PRODUCT_QUANTITY_SELECTOR);
                loopHandleAddToCart(n, t, l?.value, e)
            }))
        }))
    }))
}
async function applyShopifyDiscountLoop(o) {
    try {
        const e = `${window?.Shopify?.routes?.root}discount/${o}`;
        await fetch(e, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
    } catch (o) {
        enableAddToCartBtnLoop(productId)
    }
}
async function createBundleTransaction(o) {
    try {
        const e = await fetch(CREATE_BUNDLE_TRANSACTION_API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(o)
        });
        return (await e.json()).loopBundleGuid
    } catch (o) {
        throw console.error("createBundleTransaction", o), o
    }
}

function hideOneTimePurchaseOptionLoop(o) {
    document.querySelectorAll(`form[data-loop-product-id="${o}"]`).forEach((o => {
        o.querySelectorAll(".loop-one-time-purchase-option").forEach((o => {
            o.classList.add("loop-display-none")
        }))
    }))
}

function disableAddToCartBtnLoop(o) {
    document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
        o.querySelectorAll("button").forEach((o => {
            o.disabled = !0
        }))
    }))
}

function enableAddToCartBtnLoop(o) {
    document.querySelectorAll(`[data-loop-product-id="${o}"]`).forEach((o => {
        o.querySelectorAll("button").forEach((o => {
            o.disabled = !1
        }))
    }))
}

function createBundleTransactionPayload(o, e, n) {
    const t = window.loopProps[o].selectedVariantId,
        l = window.loopProps[o].productBundleData;
    let i = null,
        p = {};
    if (n) {
        let o = l?.productVariantDiscountMapping?.[t]?.find((o => "SUBSCRIPTION" === o.purchaseType));
        o && (p = o, i = o.bundleDiscountId)
    } else {
        let o = l?.productVariantDiscountMapping?.[t]?.find((o => "SUBSCRIPTION" !== o.purchaseType));
        o && (p = o, i = o.bundleDiscountId)
    }
    return i ? {
        payload: {
            bundleId: l.bundleId,
            bundleVariantId: l?.productVariantMapping?.[t],
            bundleDiscountId: i,
            sellingPlanId: l?.productVariantSellingPlanMapping?.[n],
            productsQuantity: Number(e)
        },
        bundleVariantDiscount: p
    } : {
        payload: null,
        bundleVariantDiscount: null
    }
}
async function handleBundleTransaction(o, e, n) {
    try {
        const {
            payload: t,
            bundleVariantDiscount: l
        } = createBundleTransactionPayload(o, e, n), i = await createBundleTransaction(t);
        return i || enableAddToCartBtnLoop(o), {
            bundleTransactionId: i,
            bundleVariantDiscount: l
        }
    } catch (e) {
        enableAddToCartBtnLoop(o)
    }
}

function getSelectedSellingPlanLoop(o) {
    let e = null;
    return document.querySelectorAll(`form[data-loop-product-id="${o}"]`).forEach((o => {
        const n = o.querySelector('input[name="selling_plan"]');
        n?.value && (e = Number(n.value))
    })), e
}
async function getBundleDiscountAttributesLoop() {
    const o = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`,
        e = await (await fetch(o)).json(),
        n = e.attributes?._loopBundleDiscountAttributes ? JSON.parse(e.attributes._loopBundleDiscountAttributes) : {},
        t = new Set(e.items.map((o => o.properties?._bundleId)).filter((o => o)));
    return Object.keys(n).filter((o => t.has(o))).reduce(((o, e) => (o[e] = n[e], o)), {})
}
async function createAddToCartPayloadLoop(o, e, n, t, l, i) {
    const p = {
            items: [],
            attributes: {
                _loopBundleDiscountAttributes: {}
            }
        },
        r = await getBundleDiscountAttributesLoop(),
        a = {};
    a[o] = {
        discountType: e.bundleDiscountType,
        discountValue: e.bundleDiscountValue,
        discountComputedValue: e ? n ? e.spbpDiscount[n] * l : e.bundleDiscountComputedValue * l : 0
    }, p.attributes._loopBundleDiscountAttributes = JSON.stringify({
        ...r,
        ...a
    });
    const s = i.mapping?.[t].childProducts ?? bundleVariants[t].childProducts;
    return s?.length && s.forEach((e => {
        const t = {
            id: e.childVariantId,
            quantity: e.quantity * l,
            selling_plan: n,
            properties: {
                _bundleId: o,
                _isPresetBundleProduct: !0
            }
        };
        i.showBundleName ? t.properties.bundleName = i?.loopBundleName ?? "" : t.properties._bundleName = i?.loopBundleName ?? "", p.items.push(t)
    })), p
}
async function shopifyAddToCartByLoop(o, e) {
    const n = `${window.Shopify.routes.root}cart/add.js`;
    fetch(n, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(o)
    }).then((o => o.json())).then((async o => {
        await dispatchLoopAddCartEvent(e, o, null)
    })).catch((o => {
        console.error("shopifyAddToCartByLoop", o), enableAddToCartBtnLoop(e)
    }))
}
async function loopHandleAddToCart(o, e, n = 1, t) {
    o.preventDefault(), o.stopPropagation(), disableAddToCartBtnLoop(e);
    const l = window.loopProps[e].selectedVariantId;
    if (!t[l].allowCheckout) return console.warn("cannot checkout bundle product"), void disableAddToCartBtnLoop(e);
    const i = window.loopProps[e].productBundleData;
    let p = getSelectedSellingPlanLoop(e);
    const {
        bundleTransactionId: r,
        bundleVariantDiscount: a
    } = await handleBundleTransaction(e, n, p);
    if (!r) return;
    const s = await createAddToCartPayloadLoop(r, a, p, l, n, i);
    await shopifyAddToCartByLoop(s, e)
}
async function dispatchLoopAddCartEvent(o, e, n) {
    const t = new CustomEvent("loopPresetAddToCartSuccessEvent", {
        detail: {
            productId: o,
            response: e
        }
    });
    document.dispatchEvent(t)
}

function updatePrepaidPriceInUILoop({
    productId: o
}) {
    const e = window.loopProps[o].prepaidSellingPlans;
    if (!window.loopProps[o]?.prepaidSellingPlans) return;
    let n = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
        t = window.loopProps && window.loopProps[o] ? window.loopProps[o].sellingPlan : {};
    const l = window.loopProps[o]?.product || {},
        {
            selling_plan_groups: i
        } = l,
        {
            selling_plan_allocations: p
        } = n;
    if (i.map((o => {
            if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
                let t = o.selling_plans[0];
                if (!e[t.id] || !e[t.id]?.isPrepaidV2) return;
                e[t.id];
                let l = p.find((o => Number(o.selling_plan_id) === Number(t.id))) || {};
                const {
                    selling_plan_group_id: i,
                    per_delivery_price: r
                } = l;
                let a = document.querySelector(`#loop-price-${n.id}-${i}`);
                a && (a.innerHTML = loopFormatMoney(r, !0))
            }
        })), t && t.selling_plan_group_id) {
        const {
            selling_plan_group_id: o,
            per_delivery_price: l
        } = t;
        if (!e[t.selling_plan_id] || !e[t.selling_plan_id]?.isPrepaidV2) return;
        e[t.selling_plan_id];
        let i = document.querySelector(`#loop-price-${n.id}-${o}`);
        i && (i.innerHTML = loopFormatMoney(l, !0))
    }
}

function hideDifferentVariantSellingPlansLoop(o) {
    o.variants.forEach((o => {
        var e = o.selling_plan_allocations.map((o => o.selling_plan_id.toString()));
        o.selling_plan_allocations.forEach((n => {
            const t = document.querySelector(`#loop-select-${o.id}-${n.selling_plan_group_id}`);
            if (t) {
                t.querySelectorAll("option.loop-selling-plan-selector-option").forEach((function(o) {
                    e.includes(o.value) || o.remove()
                }))
            }
        }))
    }))
}
window.loopPurchaseChoice = window.loopPurchaseChoice || {}, window.loopHasInitializedDefaults = window.loopHasInitializedDefaults || {};